import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject, EventEmitter, Directive, Input, Output, Component, Pipe, ViewChildren, HostBinding, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import * as i2 from '@highfieldabc/angular-highfieldauth';
import { AngularHighfieldauthModule } from '@highfieldabc/angular-highfieldauth';
import * as i4$1 from '@highfieldabc/angular-highfieldcommon';
import { AngularHighfieldcommonModule } from '@highfieldabc/angular-highfieldcommon';
import * as i3 from '@highfieldabc/angular-highfieldlayout';
import { AngularHighfieldlayoutModule, LoginComponent } from '@highfieldabc/angular-highfieldlayout';
import * as i1 from '@highfieldabc/angular-highfieldwebapi';
import { AngularHighfieldwebapiModule } from '@highfieldabc/angular-highfieldwebapi';
import * as i3$1 from '@angular/common';
import { Location, LocationStrategy, PathLocationStrategy, CommonModule } from '@angular/common';
import * as i1$2 from '@angular/router';
import { NavigationEnd, RouterModule, NavigationStart } from '@angular/router';
import { catchError, of, Subject, Observable, BehaviorSubject, from, EMPTY, concatMap } from 'rxjs';
import { BlobServiceClient, AnonymousCredential } from '@azure/storage-blob';
import * as ClientZip from 'client-zip';
import { mergeMap, map, toArray, expand, distinct, switchMap } from 'rxjs/operators';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i2$1 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i3$2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i6 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i8 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i5 from '@angular/cdk/clipboard';
import { ClipboardModule } from '@angular/cdk/clipboard';
function NodeActionComponent_ng_container_0_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_button_7_Template_button_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r6);
      const action_r4 = restoredCtx.$implicit;
      const ctx_r5 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r5.onActionClicked(action_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(action_r4);
  }
}
function NodeActionComponent_ng_container_0_div_8_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r23);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r21 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r21.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 24);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r26);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r24 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r24.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 27);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r29);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r27 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r27.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 28);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r32);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r30 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r30.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 30);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 31);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r35);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r33 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r33.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 32);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 33);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r38);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r36 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r36.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 34);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 35);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r41);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r39 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r39.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 36);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r44);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r42 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r42.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 38);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 39);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r47);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r45 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r45.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 40);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 41);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r50);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r48 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r48.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 42);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r53);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r51 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r51.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r56);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r54 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r54.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 46);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_button_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 47);
    i0.ɵɵlistener("click", function NodeActionComponent_ng_container_0_div_8_button_13_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r59);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const ctx_r57 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r57.onActionClicked(action_r7));
    });
    i0.ɵɵelement(1, "i", 44);
    i0.ɵɵelementEnd();
  }
}
function NodeActionComponent_ng_container_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NodeActionComponent_ng_container_0_div_8_button_1_Template, 2, 0, "button", 10)(2, NodeActionComponent_ng_container_0_div_8_button_2_Template, 2, 0, "button", 11)(3, NodeActionComponent_ng_container_0_div_8_button_3_Template, 2, 0, "button", 12)(4, NodeActionComponent_ng_container_0_div_8_button_4_Template, 2, 0, "button", 13)(5, NodeActionComponent_ng_container_0_div_8_button_5_Template, 2, 0, "button", 14)(6, NodeActionComponent_ng_container_0_div_8_button_6_Template, 2, 0, "button", 15)(7, NodeActionComponent_ng_container_0_div_8_button_7_Template, 2, 0, "button", 16)(8, NodeActionComponent_ng_container_0_div_8_button_8_Template, 2, 0, "button", 17)(9, NodeActionComponent_ng_container_0_div_8_button_9_Template, 2, 0, "button", 18)(10, NodeActionComponent_ng_container_0_div_8_button_10_Template, 2, 0, "button", 19)(11, NodeActionComponent_ng_container_0_div_8_button_11_Template, 2, 0, "button", 20)(12, NodeActionComponent_ng_container_0_div_8_button_12_Template, 2, 0, "button", 21)(13, NodeActionComponent_ng_container_0_div_8_button_13_Template, 2, 0, "button", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Add File");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Add Folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Open Folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Download All");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Download");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Play Video");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Play Audio");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "View Image");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Upload New Version");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "View Previous Versions");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Delete File");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Delete Contents");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7 == "Delete Folder");
  }
}
function NodeActionComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "button", 3);
    i0.ɵɵelement(4, "i", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-menu", 5, 6);
    i0.ɵɵtemplate(7, NodeActionComponent_ng_container_0_button_7_Template, 2, 1, "button", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(8, NodeActionComponent_ng_container_0_div_8_Template, 14, 13, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const _r1 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("matMenuTriggerFor", _r1);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r0.actions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.actions);
  }
}
function TreeListComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 13);
    i0.ɵɵtext(1, "Type");
    i0.ɵɵelementEnd();
  }
}
function TreeListComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 14);
    i0.ɵɵtext(1, "Version");
    i0.ɵɵelementEnd();
  }
}
function TreeListComponent_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 15);
    i0.ɵɵtext(1, "Uploaded by");
    i0.ɵɵelementEnd();
  }
}
function TreeListComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵtext(1, "Upload date");
    i0.ɵɵelementEnd();
  }
}
function TreeListComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 17);
    i0.ɵɵtext(1, "Actions");
    i0.ɵɵelementEnd();
  }
}
function TreeListComponent_tr_18_Conditional_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22)(1, "span", 23);
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵattribute("aria-expanded", node_r6.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("", node_r6.icon, " fa-lg");
  }
}
function TreeListComponent_tr_18_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "span", 24);
    i0.ɵɵlistener("click", function TreeListComponent_tr_18_Conditional_3_ng_container_2_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r19);
      const node_r6 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.emitAction(node_r6.id, "Open Folder"));
    });
    i0.ɵɵelement(3, "i");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵclassMap(node_r6.icon);
  }
}
function TreeListComponent_tr_18_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 13);
    i0.ɵɵtemplate(1, TreeListComponent_tr_18_Conditional_3_div_1_Template, 3, 4, "div", 19)(2, TreeListComponent_tr_18_Conditional_3_ng_container_2_Template, 4, 3, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.icon !== "fa-solid fa-folder fa-xl");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.children && node_r6.icon === "fa-solid fa-folder fa-xl");
  }
}
function TreeListComponent_tr_18_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22)(1, "span", 24);
    i0.ɵɵlistener("click", function TreeListComponent_tr_18_div_5_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r24);
      const node_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.emitAction(node_r6.id, "Details"));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3, "\xA0\xA0 ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵattribute("aria-expanded", node_r6.expanded);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("\xA0", node_r6.name, "");
  }
}
function TreeListComponent_tr_18_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 22)(2, "span", 24);
    i0.ɵɵlistener("click", function TreeListComponent_tr_18_ng_container_6_Template_span_click_2_listener() {
      i0.ɵɵrestoreView(_r28);
      const node_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.emitAction(node_r6.id, "Open Folder"));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\xA0\xA0 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("\xA0", node_r6.name, "");
  }
}
function TreeListComponent_tr_18_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.versionCount, " ");
  }
}
function TreeListComponent_tr_18_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 14);
    i0.ɵɵtemplate(1, TreeListComponent_tr_18_Conditional_7_ng_container_1_Template, 2, 1, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.icon !== "fa-solid fa-folder fa-xl");
  }
}
function TreeListComponent_tr_18_Conditional_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.uploadedByName, " ");
  }
}
function TreeListComponent_tr_18_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 15);
    i0.ɵɵtemplate(1, TreeListComponent_tr_18_Conditional_8_ng_container_1_Template, 2, 1, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.icon !== "fa-solid fa-folder fa-xl");
  }
}
function TreeListComponent_tr_18_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, node_r6.lastUploadedDate + "Z", "dd/MM/yyyy HH:mm:ss a"), " ");
  }
}
function TreeListComponent_tr_18_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 16);
    i0.ɵɵtemplate(1, TreeListComponent_tr_18_Conditional_9_ng_container_1_Template, 3, 4, "ng-container", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.icon !== "fa-solid fa-folder fa-xl");
  }
}
function TreeListComponent_tr_18_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 25)(1, "app-node-action", 26);
    i0.ɵɵlistener("actionClick", function TreeListComponent_tr_18_Conditional_10_Template_app_node_action_actionClick_1_listener($event) {
      i0.ɵɵrestoreView(_r41);
      const node_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r39 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r39.emitAction(node_r6.id, $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("actions", node_r6.actions);
  }
}
function TreeListComponent_tr_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr")(1, "td", 13)(2, "input", 5);
    i0.ɵɵtwoWayListener("ngModelChange", function TreeListComponent_tr_18_Template_input_ngModelChange_2_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r44);
      const node_r6 = restoredCtx.$implicit;
      i0.ɵɵtwoWayBindingSet(node_r6.selected, $event) || (node_r6.selected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function TreeListComponent_tr_18_Template_input_change_2_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r44);
      const node_r6 = restoredCtx.$implicit;
      const ctx_r45 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r45.onSelectionChange(node_r6));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(3, TreeListComponent_tr_18_Conditional_3_Template, 3, 2, "td", 6);
    i0.ɵɵelementStart(4, "td", 18);
    i0.ɵɵtemplate(5, TreeListComponent_tr_18_div_5_Template, 4, 2, "div", 19)(6, TreeListComponent_tr_18_ng_container_6_Template, 5, 1, "ng-container", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, TreeListComponent_tr_18_Conditional_7_Template, 2, 1, "td", 8)(8, TreeListComponent_tr_18_Conditional_8_Template, 2, 1, "td", 9)(9, TreeListComponent_tr_18_Conditional_9_Template, 2, 1, "td", 10)(10, TreeListComponent_tr_18_Conditional_10_Template, 2, 1, "td", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", node_r6.selected);
    i0.ɵɵadvance();
    i0.ɵɵconditional(3, ctx_r5.configuration.showTypeColumn ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", node_r6.icon !== "fa-solid fa-folder fa-xl");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.children && node_r6.icon === "fa-solid fa-folder fa-xl");
    i0.ɵɵadvance();
    i0.ɵɵconditional(7, ctx_r5.configuration.showVersionColumn ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(8, ctx_r5.configuration.showUploadedByColumn ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(9, ctx_r5.configuration.showUploadedDateColumn ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(10, ctx_r5.configuration.showActionColumn ? 10 : -1);
  }
}
function AddFolderComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵtext(2, " \xA0 Folder Name is required. ");
    i0.ɵɵelementEnd();
  }
}
function AddFolderComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelement(1, "i", 13);
    i0.ɵɵtext(2, " \xA0 Folder Name must be less than 255 characters. ");
    i0.ɵɵelementEnd();
  }
}
function AddFolderComponent_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function AddFolderComponent_button_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.save());
    });
    i0.ɵɵelement(1, "i", 15);
    i0.ɵɵtext(2, " \xA0 Save ");
    i0.ɵɵelementEnd();
  }
}
function FileUploadComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵlistener("filesChangeEmitter", function FileUploadComponent_div_3_Template_div_filesChangeEmitter_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r6.filesSelectedByDrop($event));
    });
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵelement(2, "i", 13)(3, "br");
    i0.ɵɵelementStart(4, "p", 14);
    i0.ɵɵtext(5, "Drag and drop files here");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 14);
    i0.ɵɵtext(7, "or");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 15);
    i0.ɵɵlistener("change", function FileUploadComponent_div_3_Template_input_change_8_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r8 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r8.filesSelectedByClick($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "label", 16)(10, "span", 17);
    i0.ɵɵtext(11, "Browse for files");
    i0.ɵɵelementEnd()()()();
  }
}
function FileUploadComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 18)(2, "div", 19);
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 21)(5, "h5", 22)(6, "strong");
    i0.ɵɵtext(7, "Warning");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "p", 14);
    i0.ɵɵtext(9, " Your files are being submitted. Please do not close this window or click the Back button on your browser. Please wait until the progression bar has completed and closed automatically. ");
    i0.ɵɵelementEnd()()()();
  }
}
function FileUploadComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵlistener("click", function FileUploadComponent_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.upload());
    });
    i0.ɵɵelement(1, "i", 24);
    i0.ɵɵtext(2, " \xA0 Upload");
    i0.ɵɵelementEnd();
  }
}
function FileUploadComponent_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function FileUploadComponent_button_9_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.removeAllFiles($event));
    });
    i0.ɵɵelement(1, "i", 26);
    i0.ɵɵtext(2, " \xA0 Clear All");
    i0.ɵɵelementEnd();
  }
}
function FileUploadComponent_div_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28)(2, "div", 29)(3, "div", 30)(4, "div", 31)(5, "p", 14);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "p", 32);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 33);
    i0.ɵɵlistener("click", function FileUploadComponent_div_10_ng_container_1_Template_button_click_9_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r17);
      const i_r15 = restoredCtx.index;
      const ctx_r16 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r16.removeSingleFile(i_r15));
    });
    i0.ɵɵelement(10, "i", 34);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r14 = ctx.$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(item_r14.file.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", (item_r14.file.size / 1024 / 1024).toFixed(2), " MB");
  }
}
function FileUploadComponent_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, FileUploadComponent_div_10_ng_container_1_Template, 11, 2, "ng-container", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.filesToUpload);
  }
}
function FileUploadComponent_ng_container_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 35);
    i0.ɵɵelementStart(2, "div", 36)(3, "div", 37)(4, "p", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "p", 14)(7, "strong");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(9, "div");
    i0.ɵɵelement(10, "mat-progress-bar", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const upload_r19 = ctx.$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(upload_r19 == null ? null : upload_r19.file == null ? null : upload_r19.file.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", upload_r19 == null ? null : upload_r19.progress, "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("value", upload_r19 == null ? null : upload_r19.progress)("color", "success");
  }
}
function FileUploadComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FileUploadComponent_ng_container_11_ng_container_1_Template, 11, 4, "ng-container", 27);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r5.filesToUpload);
  }
}
function FilePreviousVersionsComponent_table_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 4)(1, "tbody")(2, "tr")(3, "td");
    i0.ɵɵtext(4, "File name:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "tr")(8, "td");
    i0.ɵɵtext(9, "Version number: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "td");
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "tr")(13, "td");
    i0.ɵɵtext(14, "Uploaded date:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "date");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "tr")(19, "td", 5)(20, "button", 6);
    i0.ɵɵlistener("click", function FilePreviousVersionsComponent_table_3_Template_button_click_20_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r3);
      const displayFileDetails_r1 = restoredCtx.$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.downloadPreviousFileVersion(displayFileDetails_r1.id));
    });
    i0.ɵɵelement(21, "i", 7);
    i0.ɵɵtext(22, " \xA0 Download file ");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const displayFileDetails_r1 = ctx.$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", displayFileDetails_r1.fileName, "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(displayFileDetails_r1.versionNumber);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(17, 3, displayFileDetails_r1.uploadedDate + "Z", "dd/MM/yyyy HH:mm:ss a"));
  }
}
function UploadedFilesComponent_Conditional_1_ng_container_1_button_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "i", 16);
    i0.ɵɵelementContainerEnd();
  }
}
const _c0 = a0 => ({
  "fa-solid fa-house": a0
});
function UploadedFilesComponent_Conditional_1_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵlistener("click", function UploadedFilesComponent_Conditional_1_ng_container_1_button_1_Template_button_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r14);
      const crumb_r9 = restoredCtx.$implicit;
      const ctx_r13 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r13.onOpenFolder(crumb_r9.id));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "i", 15);
    i0.ɵɵtemplate(3, UploadedFilesComponent_Conditional_1_ng_container_1_button_1_ng_container_3_Template, 2, 0, "ng-container", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const crumb_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const c_r11 = ctx.count;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", crumb_r9.name, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, i_r10 == 0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r10 < c_r11);
  }
}
function UploadedFilesComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 12);
    i0.ɵɵtemplate(1, UploadedFilesComponent_Conditional_1_ng_container_1_button_1_Template, 4, 5, "button", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r7.breadCrumbs.slice().reverse());
  }
}
function UploadedFilesComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, UploadedFilesComponent_Conditional_1_ng_container_1_Template, 2, 1, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.breadCrumbs && ctx_r0.breadCrumbs.length > 0);
  }
}
function UploadedFilesComponent_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function UploadedFilesComponent_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.onAddFile(ctx_r15.parentId, ctx_r15.categoryId));
    });
    i0.ɵɵelement(1, "i", 18);
    i0.ɵɵtext(2, " \xA0 Add File(s)");
    i0.ɵɵelementEnd();
  }
}
function UploadedFilesComponent_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function UploadedFilesComponent_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.onAddFolder(ctx_r17.parentId, ctx_r17.categoryId));
    });
    i0.ɵɵelement(1, "i", 19);
    i0.ɵɵtext(2, " \xA0 Create Folder");
    i0.ɵɵelementEnd();
  }
}
function UploadedFilesComponent_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function UploadedFilesComponent_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.downloadSelectedFiles());
    });
    i0.ɵɵtext(1, " Download Selected");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r3.enableButtonOnSelected());
  }
}
function UploadedFilesComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵlistener("click", function UploadedFilesComponent_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r22);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.deleteSelectedFiles());
    });
    i0.ɵɵtext(1, " Delete Selected");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r4.enableButtonOnSelected());
  }
}
function UploadedFilesComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "app-tree-list", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nodes", ctx_r5.nodes)("configuration", ctx_r5.configuration);
  }
}
function UploadedFilesComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 23);
    i0.ɵɵelement(2, "mat-spinner", 24);
    i0.ɵɵelementEnd()();
  }
}
function PlayVideoComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "video", 1);
    i0.ɵɵelement(2, "source", 2);
    i0.ɵɵtext(3, " Your browser does not support the video tag. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.url, i0.ɵɵsanitizeUrl);
  }
}
function PlayAudioComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "audio", 1);
    i0.ɵɵelement(2, "source", 2);
    i0.ɵɵtext(3, " Your browser does not support the video tag. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.audioUrl, i0.ɵɵsanitizeUrl)("type", ctx_r0.audioMimeType);
  }
}
function FileUploadMultipleComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1, "All Uploads Complete");
    i0.ɵɵelementEnd();
  }
}
function FileUploadMultipleComponent_highfieldlayout_button_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "highfieldlayout-button", 6);
  }
}
function FileDetailsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "b");
    i0.ɵɵtext(7, "File Name:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 4)(11, "div", 5)(12, "b");
    i0.ɵɵtext(13, "Version Number:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 6);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 4)(17, "div", 5)(18, "b");
    i0.ɵɵtext(19, "Uploaded Date:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 6);
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 4)(23, "div", 5)(24, "b");
    i0.ɵɵtext(25, "Uploaded By:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 6);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "div", 4)(29, "div", 5)(30, "b");
    i0.ɵɵtext(31, "Mime Type:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 6);
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(34, "div", 7);
    i0.ɵɵelement(35, "highfieldlayout-button", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.displayFileDetails.entityName);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayFileDetails.fileName, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayFileDetails.versionNumber, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dateTimeService.convertUtcToFormattedLocalString(ctx_r0.displayFileDetails.uploadedDate, "DD/MM/YYYY HH:mm"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayFileDetails.uploadedBy, " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.displayFileDetails.mimeType, " ");
  }
}
function FileDetailsSideViewComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "H4");
    i0.ɵɵelement(2, "i");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 2)(5, "div", 3)(6, "table", 4)(7, "tbody")(8, "tr")(9, "td", 5);
    i0.ɵɵtext(10, "File name:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "tr")(14, "td");
    i0.ɵɵtext(15, "Version number:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "td");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "tr")(19, "td");
    i0.ɵɵtext(20, "Uploaded by:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "td");
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(23, "tr")(24, "td");
    i0.ɵɵtext(25, "Uploaded date:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "td");
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "date");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(29, "div", 3)(30, "div", 6)(31, "button", 7);
    i0.ɵɵlistener("cdkCopyToClipboardCopied", function FileDetailsSideViewComponent_div_0_Template_button_cdkCopyToClipboardCopied_31_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClipboardCopy($event));
    });
    i0.ɵɵelement(32, "i", 8);
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(34, "\xA0 ");
    i0.ɵɵelementStart(35, "a", 9)(36, "i", 10);
    i0.ɵɵlistener("click", function FileDetailsSideViewComponent_div_0_Template_i_click_36_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.downloadFile(ctx_r3.displayFileDetails.id));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtext(37, " \xA0 Download file ");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(ctx_r0.fileIcon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" \xA0", ctx_r0.displayFileDetails.entityName, "");
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(ctx_r0.displayFileDetails.fileName);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.displayFileDetails.versionNumber);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.displayFileDetails.uploadedBy);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(28, 11, ctx_r0.displayFileDetails.uploadedDate + "Z", "dd/MM/yyyy h:mm:ss a"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cdkCopyToClipboard", ctx_r0.downloadLink);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" \xA0", ctx_r0.copyText, "");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r0.downloadLink, i0.ɵɵsanitizeUrl);
  }
}
let AngularHighfieldCdnModule = /*#__PURE__*/(() => {
  class AngularHighfieldCdnModule {
    static {
      this.ɵfac = function AngularHighfieldCdnModule_Factory(t) {
        return new (t || AngularHighfieldCdnModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AngularHighfieldCdnModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AngularHighfieldcommonModule, AngularHighfieldauthModule, AngularHighfieldwebapiModule, AngularHighfieldlayoutModule]
      });
    }
  }
  return AngularHighfieldCdnModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NewUploadVersion {}
class RequestService {
  constructor() {
    this.contentType = "application/json";
  }
  getResponse(response) {
    if (response.responseCode === 200 || response.responseCode === 201 || response.responseCode === 204) {
      return response.responseData ? response.responseData : null;
    }
    if (response.responseCode === 400) {
      throw new Error(response.responseData.error);
    }
    if (response.responseCode === 401) {
      throw new Error("Unauthorised");
    }
    throw new Error("Internal server error");
  }
}
let AuthRequestService = /*#__PURE__*/(() => {
  class AuthRequestService extends RequestService {
    constructor(authenticatedService, baseUrl) {
      super();
      this.authenticatedService = authenticatedService;
      this.baseUrl = baseUrl;
    }
    async get(resource) {
      const response = await this.authenticatedService.getAsync(this.baseUrl, resource, this.contentType);
      return this.getResponse(response);
    }
    async post(resource, data) {
      const response = await this.authenticatedService.postAsync(this.baseUrl, resource, data);
      return this.getResponse(response);
    }
    async put(resource, data) {
      const response = await this.authenticatedService.putAsync(this.baseUrl, resource, data);
      return this.getResponse(response);
    }
    async delete(resource) {
      await this.authenticatedService.deleteAsync(this.baseUrl, resource);
    }
    static {
      this.ɵfac = function AuthRequestService_Factory(t) {
        return new (t || AuthRequestService)(i0.ɵɵinject(i2.AuthenticatedService), i0.ɵɵinject('CDNApiBaseUrl'));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AuthRequestService,
        factory: AuthRequestService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return AuthRequestService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UnauthorisedService = /*#__PURE__*/(() => {
  class UnauthorisedService {
    constructor(apiService, settingService) {
      this.apiService = apiService;
      this.settingService = settingService;
    }
    //#region Promise functions
    async getAsync(serviceBaseURL, requestUri, contentType = 'application/json') {
      const response = await new Promise(resolve => {
        this.apiService.getAsync(serviceBaseURL, requestUri, null).then(res => {
          resolve(res);
        }, async err => {
          resolve(err);
        });
      });
      return response;
    }
    async postAsync(serviceBaseURL, requestUri, body, contentType = 'application/json') {
      const response = await new Promise(resolve => {
        this.apiService.postAsync(serviceBaseURL, requestUri, null, body).then(res => {
          resolve(res);
        }, async err => {
          resolve(err);
        });
      });
      return response;
    }
    async putAsync(serviceBaseURL, requestUri, body, contentType = 'application/json') {
      const response = await new Promise(resolve => {
        this.apiService.putAsync(serviceBaseURL, requestUri, null, body).then(res => {
          resolve(res);
        }, async err => {
          resolve(err);
        });
      });
      return response;
    }
    async deleteAsync(serviceBaseURL, requestUri, contentType = 'application/json') {
      const response = await new Promise(resolve => {
        this.apiService.deleteAsync(serviceBaseURL, requestUri, null).then(res => {
          resolve(res);
        }, async err => {
          resolve(err);
        });
      });
      return response;
    }
    async getTypedAsync(serviceBaseURL, requestUri, contentType = 'application/json') {
      const response = await this.getAsync(serviceBaseURL, requestUri, contentType);
      return this.getResponse(response);
    }
    async postTypedAsync(serviceBaseURL, requestUri, body, contentType = 'application/json') {
      const response = await this.postAsync(serviceBaseURL, requestUri, body, contentType);
      return this.getResponse(response);
    }
    async putTypedAsync(serviceBaseURL, requestUri, body, contentType = 'application/json') {
      const response = await this.putAsync(serviceBaseURL, requestUri, body, contentType);
      return this.getResponse(response);
    }
    async getFileAsync(serviceBaseURL, requestUri, contentType = 'application/pdf') {
      const response = await new Promise(resolve => {
        this.apiService.getFileAsync(serviceBaseURL, requestUri, null).then(res => {
          resolve(res);
        }, async err => {
          resolve(err);
        });
      });
      return response;
    }
    getResponse(response) {
      if (response.responseCode === 200 || response.responseCode === 201 || response.responseCode === 204) {
        if (response.responseData == null || response.responseData == undefined) {
          return null;
        }
        return response.responseData;
      }
      if (response.responseCode === 400) {
        throw new Error(response.responseError);
      }
      if (response.responseCode === 401) {
        throw new Error("Unauthorised");
      }
      throw new Error("Internal server error");
    }
    //#endregion Promise functions
    //#region Observable functions
    getObservable(serviceBaseURL, requestUri, contentType = 'application/json') {
      const getRequest = () => this.apiService.getObservable(serviceBaseURL, requestUri, null);
      return getRequest().pipe(catchError(error => this.getDefaultError(error) // Non-401 error, return GenericAPIResponse with error messages
      ));
    }
    postObservable(serviceBaseURL, requestUri, body, contentType = 'application/json') {
      const postRequest = () => this.apiService.postObservable(serviceBaseURL, requestUri, null, body);
      return postRequest().pipe(catchError(error => this.getDefaultError(error) // Non-401 error, return GenericAPIResponse with error messages
      ));
    }
    putObservable(serviceBaseURL, requestUri, body, contentType = 'application/json') {
      const putRequest = () => this.apiService.putObservable(serviceBaseURL, requestUri, null, body);
      return putRequest().pipe(catchError(error => this.getDefaultError(error) // Non-401 error, return GenericAPIResponse with error messages
      ));
    }
    deleteObservable(serviceBaseURL, requestUri, contentType = 'application/json') {
      const deleteRequest = () => this.apiService.deleteObservable(serviceBaseURL, requestUri, null);
      return deleteRequest().pipe(catchError(error => this.getDefaultError(error) // Non-401 error, return GenericAPIResponse with error messages
      ));
    }
    //#endregion Observable functions
    //#region Support functions
    getDefaultError(error) {
      return of({
        responseCode: error.status,
        responseMessage: error.name,
        responseError: error.message
      });
    }
    static {
      this.ɵfac = function UnauthorisedService_Factory(t) {
        return new (t || UnauthorisedService)(i0.ɵɵinject(i1.APIService), i0.ɵɵinject(i1.StoredSettingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UnauthorisedService,
        factory: UnauthorisedService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return UnauthorisedService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CdnProxyRequestService = /*#__PURE__*/(() => {
  class CdnProxyRequestService extends RequestService {
    constructor(baseUrl, unauthorisedService) {
      super();
      this.baseUrl = baseUrl;
      this.unauthorisedService = unauthorisedService;
    }
    async get(resource) {
      const response = await this.unauthorisedService.getAsync(this.baseUrl, resource, this.contentType);
      return this.getResponse(response);
    }
    async post(resource, data) {
      const response = await this.unauthorisedService.postAsync(this.baseUrl, resource, data);
      return this.getResponse(response);
    }
    async put(resource, data) {
      const response = await this.unauthorisedService.putAsync(this.baseUrl, resource, data);
      return this.getResponse(response);
    }
    async delete(resource) {
      await this.unauthorisedService.deleteAsync(this.baseUrl, resource);
    }
    static {
      this.ɵfac = function CdnProxyRequestService_Factory(t) {
        return new (t || CdnProxyRequestService)(i0.ɵɵinject('CDNApiBaseUrl'), i0.ɵɵinject(UnauthorisedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CdnProxyRequestService,
        factory: CdnProxyRequestService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return CdnProxyRequestService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileService = /*#__PURE__*/(() => {
  class FileService {
    constructor(authRequestService, proxyRequestService) {
      this.authRequestService = authRequestService;
      this.proxyRequestService = proxyRequestService;
    }
    async deleteFileInfo(fileId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.get(`api/Proxy/DeleteFileInfo/${fileId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.get(`api/File/DeleteFileInfo/${fileId}`);
      }
    }
    async deleteEntity(entityId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.delete(`api/Proxy/Delete/${entityId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.delete(`api/File/Delete/${entityId}`);
      }
    }
    async deleteVersion(entityVersionId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.delete(`api/Proxy/DeleteVersion/${entityVersionId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.delete(`api/File/DeleteVersion/${entityVersionId}`);
      }
    }
    async deleteContents(folderId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.delete(`api/Proxy/DeleteContents/${folderId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.delete(`api/File/DeleteContents/${folderId}`);
      }
    }
    async uploadFile(file, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        let proxyUpload = file;
        proxyUpload.userId = proxyUser;
        proxyUpload.categoryId = categoryId;
        return await this.proxyRequestService.post("api/Proxy/Upload", proxyUpload);
      } else {
        return await this.authRequestService.post("api/File/Upload", file);
      }
    }
    async uploadFileVersion(versionFile, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        let proxyUpload = versionFile;
        proxyUpload.userId = proxyUser;
        proxyUpload.categoryId = categoryId;
        return await this.proxyRequestService.post("api/Proxy/UploadVersion", proxyUpload);
      } else {
        return await this.authRequestService.post("api/File/UploadVersion", versionFile);
      }
    }
    async confirmUpload(versionId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.get(`api/Proxy/ConfirmUpload/${versionId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.get("api/File/ConfirmUpload/" + versionId);
      }
    }
    async getUploadedFiles(params, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        let proxyParams = params;
        proxyParams.userId = proxyUser;
        proxyParams.categoryId = categoryId;
        return await this.proxyRequestService.post("api/Proxy/GetUploadedFiles", params);
      } else {
        return await this.authRequestService.post("api/File/GetUploadedFiles", params);
      }
    }
    async getUploadedFilesForMany(paramsList, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        let proxyUploadList = paramsList;
        proxyUploadList.forEach(proxyUpload => {
          proxyUpload.userId = proxyUser;
          proxyUpload.categoryId = categoryId;
        });
        return await this.proxyRequestService.post("api/Proxy/GetUploadedFilesForMany", paramsList);
      } else {
        return await this.authRequestService.post("api/File/GetUploadedFilesForMany", paramsList);
      }
    }
    async getUploadedFilesbyIds(paramsList) {
      return await this.authRequestService.post("api/File/GetUploadedSummariesById", paramsList);
    }
    async downloadFile(id, useProxy, proxyUser, categoryId) {
      let providerId = sessionStorage.getItem('cpProviderId');
      if (useProxy) {
        return await this.proxyRequestService.get(`api/Proxy/DownloadLatestVersion/${id}/${providerId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.get(`api/File/DownloadLatestVersion/${id}/${providerId}`);
      }
    }
    async getFileDetails(fileId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.get(`api/Proxy/GetFileDetails/${fileId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.get(`api/File/GetFileDetails/${fileId}`);
      }
    }
    static getFullUrl(file, useProxy, proxyUser) {
      return `${file.fileContainer}/${file.fileURL}?${file.accessToken}`;
    }
    async incrementDownloads(fileId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.post(`api/Proxy/IncrementDownloads/${fileId}/${proxyUser}/${categoryId}`, null);
      } else {
        return await this.authRequestService.post(`api/File/IncrementDownloads/${fileId}`, null);
      }
    }
    async getFilePreviousVersions(fileId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.get(`api/Proxy/GetFilePreviousVersions/${fileId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.get(`api/File/GetFilePreviousVersions/${fileId}`);
      }
    }
    async downloadFilePreviousVersion(fileId, useProxy, proxyUser, categoryId) {
      if (useProxy) {
        return await this.proxyRequestService.get(`api/Proxy/DownloadPreviousVersion/${fileId}/${proxyUser}/${categoryId}`);
      } else {
        return await this.authRequestService.get(`api/File/DownloadPreviousVersion/${fileId}`);
      }
    }
    static {
      this.ɵfac = function FileService_Factory(t) {
        return new (t || FileService)(i0.ɵɵinject(AuthRequestService), i0.ɵɵinject(CdnProxyRequestService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FileService,
        factory: FileService.ɵfac,
        providedIn: "root"
      });
    }
  }
  return FileService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TreeListService {
  constructor() {
    this.actionSource = new Subject();
    this.actionClick$ = this.actionSource.asObservable();
    this.selectedIdSource = new Subject();
    this.selectedIdClick$ = this.selectedIdSource.asObservable();
  }
  updateActionClick(item) {
    this.actionSource.next(item);
  }
  selectedUpdateIdAction(item) {
    this.selectedIdSource.next(item);
  }
}
let BlobService = /*#__PURE__*/(() => {
  class BlobService {
    async delete(uploadFile, options) {
      const blobServiceClient = new BlobServiceClient(`${uploadFile.containerURL}${uploadFile.sharedAccessSignature ?? null}`, new AnonymousCredential());
      const containerClient = blobServiceClient.getContainerClient(uploadFile.containerName);
      const blockBlobClient = containerClient.getBlockBlobClient(uploadFile.deletePath);
      try {
        const response = await blockBlobClient.deleteIfExists(options);
        return response.succeeded;
      } catch (e) {
        throw new Error(`Deleting blob failed, statusCode - ${e.statusCode}, errorCode - ${e.details.errorCode}`);
      }
    }
    upload(uploadFile, file, options) {
      if (!options) {
        options = {};
      }
      options.blobHTTPHeaders = {
        blobContentType: file.type
      };
      const blobServiceClient = new BlobServiceClient(`${uploadFile.containerURL}${uploadFile.sharedAccessSignature ?? null}`, new AnonymousCredential());
      const containerClient = blobServiceClient.getContainerClient(uploadFile.containerName);
      const blockBlobClient = containerClient.getBlockBlobClient(uploadFile.filePath);
      return new Observable(observer => {
        blockBlobClient.uploadData(file, {
          blockSize: file.size > 1024 * 1024 * 32 ? 1024 * 1024 * 4 : 1024 * 512,
          concurrency: 8,
          onProgress: this.onProgress(observer),
          blobHTTPHeaders: {
            blobContentType: file.type
          }
        }).then(this.onUploadComplete(observer, file), this.onUploadError(observer));
      });
    }
    onUploadError(observer) {
      return error => observer.error(error);
    }
    onUploadComplete(observer, file) {
      return () => {
        observer.next(file.size);
        observer.complete();
      };
    }
    onProgress(observer) {
      return progress => {
        observer.next(progress.loadedBytes);
      };
    }
    static {
      this.ɵfac = function BlobService_Factory(t) {
        return new (t || BlobService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BlobService,
        factory: BlobService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BlobService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const rotate = {
  asc: 'desc',
  desc: '',
  '': 'asc'
};
const compare = (v1, v2) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
let SortableHeaderDirective = /*#__PURE__*/(() => {
  class SortableHeaderDirective {
    constructor() {
      this.sortable = '';
      this.direction = '';
      this.sort = new EventEmitter();
    }
    rotate() {
      this.direction = rotate[this.direction];
      this.sort.emit({
        column: this.sortable,
        direction: this.direction
      });
    }
    static {
      this.ɵfac = function SortableHeaderDirective_Factory(t) {
        return new (t || SortableHeaderDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SortableHeaderDirective,
        selectors: [["th", "sortable", ""]],
        hostVars: 4,
        hostBindings: function SortableHeaderDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function SortableHeaderDirective_click_HostBindingHandler() {
              return ctx.rotate();
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("asc", ctx.direction === "asc")("desc", ctx.direction === "desc");
          }
        },
        inputs: {
          sortable: "sortable",
          direction: "direction"
        },
        outputs: {
          sort: "sort"
        }
      });
    }
  }
  return SortableHeaderDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class DownloadModel {
  constructor() {
    this.filepath = '';
  }
}
class FilePathModel {
  constructor() {
    this.id = '';
    this.linkId = '';
    this.name = '';
  }
}
let FolderDownloadService = /*#__PURE__*/(() => {
  class FolderDownloadService {
    setLoading(loading) {
      this.loadingSubject.next(loading);
    }
    constructor(httpClient, fileService, loadingService) {
      this.httpClient = httpClient;
      this.fileService = fileService;
      this.loadingService = loadingService;
      this.flatStructure = [];
      this.linkId = '';
      this.categoryId = '';
      this.loading = false;
      this.crumbs = [];
      this.loadingSubject = new BehaviorSubject(false);
      this.loading$ = this.loadingSubject.asObservable();
    }
    async downloadZip(parentFolderName, uploadSummary) {
      this.setLoading(true);
      this.flatStructure = [];
      let uploadSummary$ = of(uploadSummary);
      let flatStructure$ = this.flattenStructure(uploadSummary$);
      let fileDownloadDetails$ = this.getFileDownloadDetails(flatStructure$);
      let getFolderPath$ = this.generateFolderPath(fileDownloadDetails$);
      let downloadArray$ = getFolderPath$.pipe(mergeMap(value => {
        return from(value).pipe(map(b => {
          const file1 = new DownloadModel();
          file1.filepath = b.filepath;
          file1.filePathModel = b.filePathModel;
          return file1;
        }), toArray());
      }));
      let files = [];
      downloadArray$.subscribe(async d => {
        files = d;
        console.log("download Array:", d);
        await this.createZip(files, parentFolderName);
      });
    }
    generateFolderPath(flatStructure$) {
      return new Observable(subscriber => {
        flatStructure$.pipe(map(val => {
          this.flatStructure = val;
          return from(val).pipe(map(v => {
            let filepath = this.buildFilePaths(v).reverse().join('/');
            let filePathModel = v;
            this.crumbs = [];
            return {
              filePathModel: filePathModel,
              filepath: filepath
            };
          }), toArray());
        }), mergeMap(data => {
          return data;
        })).subscribe({
          next: data => {
            subscriber.next(data);
          },
          complete: () => {
            subscriber.complete();
          },
          error: error => {}
        });
      });
    }
    flattenStructure(uploadSummary$) {
      return new Observable(subscriber => {
        uploadSummary$.subscribe(files => {
          from(files).pipe(expand(x => {
            return x.children && x.children.length ? from(x.children) : EMPTY;
          }), map(y => {
            let model = new FilePathModel();
            model.id = y.id;
            model.linkId = y.linkId;
            model.name = y.name;
            model.type = y.type;
            return model;
          }), distinct(downloadFile => downloadFile.id), toArray()).subscribe({
            next: data => {
              subscriber.next(data);
            },
            complete: () => {
              subscriber.complete();
            },
            error: error => {}
          });
        });
      });
    }
    getFileDownloadDetails(flatStructure$) {
      return new Observable(subscriber => {
        flatStructure$.subscribe(files => {
          from(files).pipe(concatMap(val => {
            {
              if (val.type.hasChildren) {
                return of(val);
              } else {
                return this.fetchFileDownloadDetails(val.id).pipe(map(x => {
                  let model = new FilePathModel();
                  model.id = val.id;
                  model.linkId = val.linkId;
                  model.name = val.name;
                  model.type = val.type;
                  model.downloadFile = x;
                  return model;
                }));
              }
            }
          }), toArray()).subscribe({
            next: data => {
              subscriber.next(data);
            },
            complete: () => {
              subscriber.complete();
            },
            error: error => {}
          });
        });
      });
    }
    fetchFileDownloadDetails(id) {
      return from(this.fileService.downloadFile(id));
    }
    buildFilePaths(file) {
      let summary = this.flatStructure.find(x => x.id.toLowerCase() === file.id.toLowerCase());
      if (summary) {
        if (this.crumbs === undefined) {
          this.crumbs = new Array();
        }
        if (summary.type.hasChildren) {
          this.crumbs.push(summary.name);
        } else {
          const filename = summary.downloadFile?.filename;
          const lastDotIndex = filename.lastIndexOf('.');
          const fileExtension = lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : '';
          this.crumbs.push(summary.name + '.' + fileExtension);
        }
        let node = this.flatStructure.find(x => x.id.toLowerCase() === summary?.linkId.toLowerCase());
        if (node) {
          this.buildFilePaths(node);
        }
      }
      return this.crumbs;
    }
    async createZip(files, zipName) {
      let arr = [];
      await Promise.all(files.map(async downloadModel => {
        if (!downloadModel.filePathModel.type.hasChildren) {
          arr.push({
            input: (await fetch(FileService.getFullUrl(downloadModel?.filePathModel?.downloadFile))).body,
            name: downloadModel.filepath
          });
        } else {
          arr.push({
            name: downloadModel.filepath
          });
        }
      }));
      streamSaver.mitm = "https://highfieldcdnstorage.blob.core.windows.net/resources/html/mitm.html";
      var fileStream = streamSaver.createWriteStream(`${zipName}.zip`);
      const content = await ClientZip.downloadZip(arr);
      // Modern implementation
      if (window.WritableStream && !!content.body.pipeTo) {
        content.body.pipeTo(fileStream).then(() => console.log('done writing'));
      } else {
        // Backup for older browsers
        const writer = fileStream.getWriter();
        const reader = content.body.getReader();
        const pump = () => reader.read().then(res => res.done ? writer.close() : writer.write(res.value).then(pump));
        pump();
      }
      // Stops the spinner as the ZIP file is compiled and is ready to be downloaded
      this.setLoading(false);
    }
    static {
      this.ɵfac = function FolderDownloadService_Factory(t) {
        return new (t || FolderDownloadService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(FileService), i0.ɵɵinject(i3.LoadingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FolderDownloadService,
        factory: FolderDownloadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FolderDownloadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NodeActionComponent = /*#__PURE__*/(() => {
  class NodeActionComponent {
    constructor() {
      this.actions = [];
      this.actionClick = new EventEmitter();
    }
    onActionClicked(action) {
      this.actionClick.emit(action);
    }
    static {
      this.ɵfac = function NodeActionComponent_Factory(t) {
        return new (t || NodeActionComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NodeActionComponent,
        selectors: [["app-node-action"]],
        inputs: {
          actions: "actions",
          nodeId: "nodeId",
          selectedNodes: "selectedNodes"
        },
        outputs: {
          actionClick: "actionClick"
        },
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [1, "d-flex", "flex-row", "justify-content-end"], [1, "dropdown"], [1, "dropbtn", 3, "matMenuTriggerFor"], [1, "fas", "fa-ellipsis-h"], ["yPosition", "above", 1, "dropdown-content"], ["menu", "matMenu"], ["mat-menu-item", "", 3, "click", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["mat-menu-item", "", 3, "click"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Add file", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Add folder", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Open folder", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Download all", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Download", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Play video", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Play audio", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "View image", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Upload new version", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "View previous versions", 3, "click", 4, "ngIf"], ["class", "btn btn-danger btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Delete file", 3, "click", 4, "ngIf"], ["class", "btn btn-danger btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Delete contents", 3, "click", 4, "ngIf"], ["class", "btn btn-danger btn-icon me-2", "data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Delete folder", 3, "click", 4, "ngIf"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Add file", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-file-plus", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Add folder", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-folder-plus"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Open folder", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-folder-open", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Download all", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-folder-arrow-down", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Download", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-download", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Play video", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-play", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Play audio", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-headphones", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "View image", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-image", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Upload new version", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-upload", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "View previous versions", 1, "btn", "btn-primary", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-eye", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Delete file", 1, "btn", "btn-danger", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-trash", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Delete contents", 1, "btn", "btn-danger", "btn-icon", "me-2", 3, "click"], [1, "fa-solid", "fa-trash-list", "fa-lg"], ["data-bs-toggle", "tooltip", "data-bs-placement", "top", "title", "Delete folder", 1, "btn", "btn-danger", "btn-icon", "me-2", 3, "click"]],
        template: function NodeActionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NodeActionComponent_ng_container_0_Template, 9, 3, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.actions && ctx.actions.length > 0);
          }
        },
        dependencies: [i3$1.NgForOf, i3$1.NgIf, i2$1.MatMenu, i2$1.MatMenuItem, i2$1.MatMenuTrigger],
        styles: ["table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{padding:4px 0}.dropbtn[_ngcontent-%COMP%]{background-color:#fff;font-size:1rem;border:none;cursor:pointer}.dropbtn[_ngcontent-%COMP%]:hover{background-color:#d7d7d7}.dropbtn[_ngcontent-%COMP%]:focus{background-color:#d7d7d7}.dropdown[_ngcontent-%COMP%]{position:relative;display:inline-block}.dropdown-content[_ngcontent-%COMP%]{display:none;position:absolute;background-color:#f1f1f1;min-width:160px;box-shadow:0 8px 16px #0003;z-index:1}.dropdown-content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{cursor:pointer;color:#000;padding:12px 16px;text-decoration:none;display:block}.dropdown-content[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:hover{background-color:#ddd}.show[_ngcontent-%COMP%]{display:block}.hidden[_ngcontent-%COMP%]{display:none}.btn-icon[_ngcontent-%COMP%]{color:#fff;height:35px;width:35px;border-radius:50%;padding:0;margin-right:.25em}"]
      });
    }
  }
  return NodeActionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TreeListPipe = /*#__PURE__*/(() => {
  class TreeListPipe {
    transform(values, filter) {
      if (!filter || filter.length === 0 || filter === '') {
        return values;
      }
      if (values.length === 0) {
        return values;
      }
      return values.filter(value => {
        return value.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
      });
    }
    static {
      this.ɵfac = function TreeListPipe_Factory(t) {
        return new (t || TreeListPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "FilterEntitys",
        type: TreeListPipe,
        pure: true
      });
    }
  }
  return TreeListPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TreeListComponent = /*#__PURE__*/(() => {
  class TreeListComponent {
    constructor(treeListService, folderDownloadService) {
      this.treeListService = treeListService;
      this.folderDownloadService = folderDownloadService;
      this.filter = '';
      this.sortIcon = "far fa-chevron-down";
      this.entities = this.nodes;
      this.selectedNodes = [];
      this.selectAll = false;
    }
    ngOnChanges() {
      this.refreshTreeList();
    }
    refreshTreeList() {
      this.entities = this.nodes;
      this.sortIcon = "";
      this.selectAll = false;
    }
    onSelectionChange(node) {
      if (node.selected) {
        this.selectedNodes.push(node);
      } else {
        const index = this.selectedNodes.indexOf(node);
        if (index !== -1) {
          this.selectedNodes.splice(index, 1);
        }
      }
      this.selectAll = this.selectedNodes.length === this.nodes.length;
      this.updateSelectedIds();
    }
    onSelectAllChange() {
      if (this.selectAll) {
        this.selectedNodes = this.nodes.map(node => {
          node.selected = true;
          return node;
        });
      } else {
        this.nodes.forEach(node => node.selected = false);
        this.selectedNodes = [];
      }
      this.updateSelectedIds();
    }
    updateSelectedIds() {
      const selectedFileIds = this.selectedNodes.map(node => node.id);
      this.treeListService.selectedUpdateIdAction(selectedFileIds);
    }
    onSort({
      column,
      direction
    }) {
      this.headers.forEach(header => {
        if (header.sortable !== column) {
          header.direction = '';
        }
      });
      if (direction === '' || column === '') {
        this.entities = this.nodes;
        this.sortIcon = "far fa-chevron-down";
      } else {
        this.entities = [...this.nodes].sort((a, b) => {
          const res = compare(a[column], b[column]);
          this.sortIcon = direction === 'asc' ? "far fa-sort-alpha-down" : "far fa-sort-alpha-up";
          return direction === 'asc' ? res : -res;
        });
      }
    }
    emitAction(id, action) {
      const x = {
        id: id,
        action: action
      };
      this.treeListService.updateActionClick(x);
    }
    static {
      this.ɵfac = function TreeListComponent_Factory(t) {
        return new (t || TreeListComponent)(i0.ɵɵdirectiveInject(TreeListService), i0.ɵɵdirectiveInject(FolderDownloadService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TreeListComponent,
        selectors: [["app-tree-list"]],
        viewQuery: function TreeListComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(SortableHeaderDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headers = _t);
          }
        },
        inputs: {
          nodes: "nodes",
          configuration: "configuration"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 20,
        vars: 13,
        consts: [[1, "tree"], [1, "table-responsive"], [1, "table", "table-hover", "w-100"], [1, "thead-light"], [1, "col-1", 2, "align-items", "center", "white-space", "nowrap"], ["type", "checkbox", 3, "ngModel", "ngModelChange", "change"], ["class", "col-1"], ["scope", "col", "sortable", "name", 1, "col", 3, "sort"], ["class", "col-1 text-center"], ["class", "col-2 text-center"], ["class", "col-2"], ["class", "col-3 text-center"], [4, "ngFor", "ngForOf"], [1, "col-1"], [1, "col-1", "text-center"], [1, "col-2", "text-center"], [1, "col-2"], [1, "col-3", "text-center"], [1, "col"], ["class", "node", 4, "ngIf"], [4, "ngIf"], ["class", "col-3"], [1, "node"], [1, "pad-left"], [1, "pad-left", 3, "click"], [1, "col-3"], [3, "actions", "actionClick"]],
        template: function TreeListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "table", 2)(3, "thead", 3)(4, "tr")(5, "th", 4)(6, "input", 5);
            i0.ɵɵtwoWayListener("ngModelChange", function TreeListComponent_Template_input_ngModelChange_6_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.selectAll, $event) || (ctx.selectAll = $event);
              return $event;
            });
            i0.ɵɵlistener("change", function TreeListComponent_Template_input_change_6_listener() {
              return ctx.onSelectAllChange();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtext(7, " Select All");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, TreeListComponent_Conditional_8_Template, 2, 0, "th", 6);
            i0.ɵɵelementStart(9, "th", 7);
            i0.ɵɵlistener("sort", function TreeListComponent_Template_th_sort_9_listener($event) {
              return ctx.onSort($event);
            });
            i0.ɵɵtext(10, "\xA0");
            i0.ɵɵelement(11, "i");
            i0.ɵɵtext(12, "\xA0Name");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, TreeListComponent_Conditional_13_Template, 2, 0, "th", 8)(14, TreeListComponent_Conditional_14_Template, 2, 0, "th", 9)(15, TreeListComponent_Conditional_15_Template, 2, 0, "th", 10)(16, TreeListComponent_Conditional_16_Template, 2, 0, "th", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(17, "tbody");
            i0.ɵɵtemplate(18, TreeListComponent_tr_18_Template, 11, 8, "tr", 12);
            i0.ɵɵpipe(19, "FilterEntitys");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵtwoWayProperty("ngModel", ctx.selectAll);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(8, ctx.configuration.showTypeColumn ? 8 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵclassMap(ctx.sortIcon);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(13, ctx.configuration.showVersionColumn ? 13 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(14, ctx.configuration.showUploadedByColumn ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(15, ctx.configuration.showUploadedDateColumn ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(16, ctx.configuration.showActionColumn ? 16 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(19, 10, ctx.entities, ctx.filter));
          }
        },
        dependencies: [i3$1.NgForOf, i3$1.NgIf, i4.CheckboxControlValueAccessor, i4.NgControlStatus, i4.NgModel, NodeActionComponent, SortableHeaderDirective, i3$1.DatePipe, TreeListPipe],
        styles: [".tree[_ngcontent-%COMP%]{width:100%}.tree[_ngcontent-%COMP%]   table[_ngcontent-%COMP%], .tree[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%]{width:auto}.tree[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]   .col-1[_ngcontent-%COMP%], .tree[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%]   .col-1[_ngcontent-%COMP%]{width:55px}.tree[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle}.tree[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{padding-bottom:.5rem}.tree[_ngcontent-%COMP%]   th[sortable][_ngcontent-%COMP%]{cursor:pointer;user-select:none;-webkit-user-select:none}.tree[_ngcontent-%COMP%]   table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%] > tr[_ngcontent-%COMP%] > td[_ngcontent-%COMP%]{padding:10px}.tree[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{background-color:#fff;cursor:pointer}.tree[_ngcontent-%COMP%]   .node[_ngcontent-%COMP%]{display:flex;align-items:center;flex:1;padding-bottom:5px;padding-top:5px;overflow-wrap:break-word;word-break:break-all;cursor:pointer}.tree[_ngcontent-%COMP%]   .node[_ngcontent-%COMP%]   .pad-left[_ngcontent-%COMP%]{padding-left:20px}.tree[_ngcontent-%COMP%]   .node[_ngcontent-%COMP%]   .pad-left[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{padding-right:15px}.tree[_ngcontent-%COMP%]   .expand-btn[_ngcontent-%COMP%]{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%;color:#000;border-bottom:none;outline:none}.card[_ngcontent-%COMP%]:hover{border:2px solid #159ed9}.card-body[_ngcontent-%COMP%]{padding:1rem!important}.node-name[_ngcontent-%COMP%]{max-width:780px}.title[_ngcontent-%COMP%]{font-size:small;font-weight:500}.file-info[_ngcontent-%COMP%]{font-size:larger}"]
      });
    }
  }
  return TreeListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let OverviewComponent = /*#__PURE__*/(() => {
  class OverviewComponent {
    constructor(fileService, treeListService, blobService) {
      this.fileService = fileService;
      this.treeListService = treeListService;
      this.blobService = blobService;
      this.nodes = [];
    }
    async ngOnInit() {
      this.treeListService.actionClick$.subscribe(async val => {
        const result = await this.fileService.downloadFile(val.id);
        if (val.action === 'Download') {
          await this.download(result);
        }
      });
      const files = await this.fileService.getUploadedFiles({
        categoryId: "EC6A309E-1C47-44C4-A1CE-D02112039D42",
        linkId: "D4770FEF-621D-42BC-94E8-4DE0C8CC431B"
      });
      this.setNodes(files);
    }
    handleFileInput(event) {
      this.fileUpload = event.target.files[0];
    }
    async upload() {
      const upload = new NewUploadVersion();
      upload.entityId = '98C4CF82-481A-4228-9B20-01095206654A';
      upload.filename = this.fileUpload.name;
      upload.mimeType = this.fileUpload.type;
      const result = await this.fileService.uploadFileVersion(upload);
      // await this.blobService.upload(result, this.fileUpload);
    }
    async download(result) {
      if (result) {
        const url = `${result.fileContainer}/${result.fileURL}?${result.accessToken}`;
        let blob = await fetch(url).then(r => r.blob());
        const link = document.createElement("a");
        link.setAttribute('download', 'download');
        link.download = result.filename;
        link.target = "_blank";
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    }
    setNodes(files) {
      this.nodes = files.map(f => {
        return {
          id: f.id,
          name: f.name,
          children: this.setChildModeOptions(f.children),
          actions: f.fileType?.downloadOptions?.map(o => o.downloadOptionName)
        };
      });
    }
    setChildModeOptions(children) {
      let node;
      for (node of children) {
        node.actions = node.fileType?.downloadOptions?.map(o => o.downloadOptionName);
      }
      return children;
    }
    static {
      this.ɵfac = function OverviewComponent_Factory(t) {
        return new (t || OverviewComponent)(i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(TreeListService), i0.ɵɵdirectiveInject(BlobService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: OverviewComponent,
        selectors: [["app-overview"]],
        decls: 11,
        vars: 1,
        consts: [[2, "padding", "30px"], [3, "nodes"], ["for", "filename"], ["type", "file", "name", "filename", 3, "change"], ["type", "button", 3, "click"]],
        template: function OverviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1");
            i0.ɵɵtext(1, "Welcome to the Highfield Uploads System");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 0);
            i0.ɵɵelement(3, "app-tree-list", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div")(5, "form")(6, "label", 2);
            i0.ɵɵtext(7, "Click \"Choose File\" button to upload a file:");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "input", 3);
            i0.ɵɵlistener("change", function OverviewComponent_Template_input_change_8_listener($event) {
              return ctx.handleFileInput($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "button", 4);
            i0.ɵɵlistener("click", function OverviewComponent_Template_button_click_9_listener() {
              return ctx.upload();
            });
            i0.ɵɵtext(10, "Upload");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("nodes", ctx.nodes);
          }
        },
        dependencies: [TreeListComponent]
      });
    }
  }
  return OverviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NewUpload {}
let AddFolderComponent = /*#__PURE__*/(() => {
  class AddFolderComponent {
    constructor(fileService, data, dialogRef) {
      this.fileService = fileService;
      this.data = data;
      this.dialogRef = dialogRef;
      this.folderName = '';
      this.clicked = false;
      this.uploaded = new EventEmitter();
      this.linkId = data.linkId;
      this.categoryId = data.categoryId;
      this.folderId = data.folderId;
    }
    async save() {
      if (this.linkId && this.linkId.length) {
        this.clicked = true;
        await this.addNewFolder();
        this.dialogRef.close({
          event: true
        });
      }
    }
    closeDialog() {
      this.dialogRef.close({
        event: false
      });
    }
    async addNewFolder() {
      const upload = new NewUpload();
      upload.typeId = '554FC026-EFD6-40AF-8F53-B15B90ECDBC4';
      upload.linkId = this.linkId;
      upload.categoryId = this.categoryId;
      upload.title = this.folderName;
      upload.description = '';
      upload.filename = this.folderName;
      upload.mimeType = '';
      await this.fileService.uploadFile(upload);
    }
    static {
      this.ɵfac = function AddFolderComponent_Factory(t) {
        return new (t || AddFolderComponent)(i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3$2.MatDialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddFolderComponent,
        selectors: [["highfield-uploads-shared-add-folder"]],
        outputs: {
          uploaded: "uploaded"
        },
        decls: 18,
        vars: 4,
        consts: [["id", "highfield-uploads-shared-add-folder-container"], ["mat-dialog-title", ""], [1, "row"], [1, "col-12"], ["for", "foldername", 2, "font-weight", "500"], ["type", "text", "id", "name", "name", "name", "required", "", 1, "folder-input", 3, "ngModel", "ngModelChange"], ["name", "ngModel"], ["class", "error", 4, "ngIf"], [1, "gap-1"], ["class", "btn btn-success", 3, "click", 4, "ngIf"], [1, "btn", "btn-danger", 3, "click"], [1, "fa-solid", "fa-xmark"], [1, "error"], [1, "fa-solid", "fa-circle-exclamation"], [1, "btn", "btn-success", 3, "click"], [1, "fa-solid", "fa-floppy-disk"]],
        template: function AddFolderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h2", 1);
            i0.ɵɵtext(2, "Add folder");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-dialog-content")(4, "div", 2)(5, "div", 3)(6, "form")(7, "label", 4);
            i0.ɵɵtext(8, "Folder Name");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "input", 5, 6);
            i0.ɵɵtwoWayListener("ngModelChange", function AddFolderComponent_Template_input_ngModelChange_9_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.folderName, $event) || (ctx.folderName = $event);
              return $event;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(11, AddFolderComponent_div_11_Template, 3, 0, "div", 7)(12, AddFolderComponent_div_12_Template, 3, 0, "div", 7);
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelementStart(13, "mat-dialog-actions", 8);
            i0.ɵɵtemplate(14, AddFolderComponent_button_14_Template, 3, 0, "button", 9);
            i0.ɵɵelementStart(15, "button", 10);
            i0.ɵɵlistener("click", function AddFolderComponent_Template_button_click_15_listener() {
              return ctx.closeDialog();
            });
            i0.ɵɵelement(16, "i", 11);
            i0.ɵɵtext(17, " \xA0 Cancel");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            const _r0 = i0.ɵɵreference(10);
            i0.ɵɵadvance(9);
            i0.ɵɵtwoWayProperty("ngModel", ctx.folderName);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", _r0.invalid && (_r0.dirty || _r0.touched) && (_r0.errors == null ? null : _r0.errors["required"]));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.folderName.length > 255);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.clicked);
          }
        },
        dependencies: [i3$1.NgIf, i4.ɵNgNoValidate, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgControlStatusGroup, i4.RequiredValidator, i4.NgModel, i4.NgForm, i3$2.MatDialogTitle, i3$2.MatDialogActions, i3$2.MatDialogContent],
        styles: ["#highfield-uploads-shared-file-upload-container[_ngcontent-%COMP%]{height:50px}input[_ngcontent-%COMP%], label[_ngcontent-%COMP%]{display:block}.error[_ngcontent-%COMP%]{border:1px solid;margin-top:5px;padding:5px;background-repeat:no-repeat;background-position:10px center;color:#d8000c;background-color:#ffbaba;font-weight:500}.folder-input[_ngcontent-%COMP%]{padding:5px;width:100%;margin-top:5px}"]
      });
    }
  }
  return AddFolderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploadService = /*#__PURE__*/(() => {
  class FileUploadService {
    constructor(blobService, fileService) {
      this.blobService = blobService;
      this.fileService = fileService;
    }
    async uploadNewFile(fileToUpload, linkId, categoryId, useProxy, proxyUserId) {
      const upload = new NewUpload();
      upload.typeId = '5B88CEB4-FCD7-43B8-9608-A9DB372A69D4';
      upload.linkId = linkId;
      upload.categoryId = categoryId;
      if (fileToUpload.file.name.lastIndexOf(".") > -1 == true) {
        upload.title = fileToUpload.file.name.substring(0, fileToUpload.file.name.lastIndexOf("."));
      } else {
        upload.title = fileToUpload.file.name;
      }
      upload.description = '';
      upload.filename = fileToUpload.file.name;
      upload.mimeType = fileToUpload.file.type;
      return await this.fileService.uploadFile(upload, useProxy, proxyUserId, categoryId);
    }
    async confirmUpload(id) {
      try {
        await this.fileService.confirmUpload(id);
      } catch (e) {
        console.log("Failed Upload Confirmation", e);
      }
    }
    async uploadNewVersion(fileToUpload, fileId, useProxy, proxyUserId, categoryId) {
      const upload = new NewUploadVersion();
      upload.entityId = fileId;
      upload.filename = fileToUpload.file.name;
      upload.mimeType = fileToUpload.file.type;
      return await this.fileService.uploadFileVersion(upload, useProxy, proxyUserId, categoryId);
    }
    static {
      this.ɵfac = function FileUploadService_Factory(t) {
        return new (t || FileUploadService)(i0.ɵɵinject(BlobService), i0.ɵɵinject(FileService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FileUploadService,
        factory: FileUploadService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FileUploadService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileDragAndDropDirective = /*#__PURE__*/(() => {
  class FileDragAndDropDirective {
    constructor() {
      this.filesChangeEmitter = new EventEmitter();
      this.files = [];
      this.background = '#eee';
      this.borderStyle = '2px dashed';
      this.borderColor = '#696D7D';
      this.borderRadius = '5px';
    }
    onDragOver(event) {
      event.preventDefault();
      event.stopPropagation();
      this.background = 'lightgray';
      this.borderColor = '#159ed9';
      this.borderStyle = '3px solid';
    }
    onDragLeave(event) {
      event.preventDefault();
      event.stopPropagation();
      this.background = '#eee';
      this.borderColor = '#696D7D';
      this.borderStyle = '2px dashed';
    }
    onDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      this.background = '#eee';
      this.borderColor = '#696D7D';
      this.borderStyle = '2px dashed';
      this.files = event.dataTransfer.files;
      let valid_files = this.files;
      this.filesChangeEmitter.emit(valid_files);
    }
    static {
      this.ɵfac = function FileDragAndDropDirective_Factory(t) {
        return new (t || FileDragAndDropDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FileDragAndDropDirective,
        selectors: [["", "fileDragAndDrop", ""]],
        hostVars: 8,
        hostBindings: function FileDragAndDropDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("dragover", function FileDragAndDropDirective_dragover_HostBindingHandler($event) {
              return ctx.onDragOver($event);
            })("dragleave", function FileDragAndDropDirective_dragleave_HostBindingHandler($event) {
              return ctx.onDragLeave($event);
            })("drop", function FileDragAndDropDirective_drop_HostBindingHandler($event) {
              return ctx.onDrop($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("background", ctx.background)("border", ctx.borderStyle)("border-color", ctx.borderColor)("border-radius", ctx.borderRadius);
          }
        },
        outputs: {
          filesChangeEmitter: "filesChangeEmitter"
        }
      });
    }
  }
  return FileDragAndDropDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploadComponent = /*#__PURE__*/(() => {
  class FileUploadComponent {
    constructor(fileUploadService, data, dialogRef, blobService, fileService) {
      this.fileUploadService = fileUploadService;
      this.data = data;
      this.dialogRef = dialogRef;
      this.blobService = blobService;
      this.fileService = fileService;
      this.files = [];
      this.filesToUpload = [];
      this.allComplete = false;
      this.uploadsStarted = false;
      this.newFile = true;
      this.useProxy = false;
      this.proxyUserId = "";
    }
    ngOnInit() {
      this.linkId = this.data.linkId;
      this.categoryId = this.data.categoryId;
      this.fileId = this.data.fileId;
      this.newFile = this.data.newFile;
      this.useProxy = this.data.useProxy;
      this.proxyUserId = this.data.proxyUserId;
    }
    filesSelectedByClick(event) {
      this.files = event.target.files;
      let filesNames = '';
      for (var i = 0; i < this.files.length; i++) {
        this.filesToUpload.push({
          file: this.files[i],
          progress: 0,
          uploadCompleted: false
        });
        filesNames.concat(`"${this.files[i].name}"`);
      }
    }
    filesSelectedByDrop(event) {
      this.files = event;
      let filesNames = '';
      for (var i = 0; i < this.files.length; i++) {
        this.filesToUpload.push({
          file: this.files[i],
          progress: 0,
          uploadCompleted: false
        });
        filesNames.concat(`"${this.files[i].name}"`);
      }
    }
    removeSingleFile(index) {
      this.filesToUpload.splice(index, 1);
    }
    removeAllFiles(event) {
      this.files = event.target.files;
      this.filesToUpload = [];
    }
    closeDialog() {
      this.dialogRef.close();
      this.filesToUpload = [];
    }
    async upload() {
      this.uploadsStarted = true;
      const uploadTasks = [];
      const subscriptions = [];
      // TODO: Rewrite this so that it doesn't just rely on linkId/fileId "having a value" to determine which request should be called
      if (this.linkId && this.linkId.length) {
        for (let item of this.filesToUpload) {
          this.fileUploadService.uploadNewFile(item, this.linkId, this.categoryId, this.useProxy, this.proxyUserId).then(result => {
            let subscription = this.blobService.upload(result, item.file, {
              onProgress: progress => {
                const percent = progress.loadedBytes / item.file.size * 100;
                item.progress = Math.trunc(percent);
              }
            }).subscribe({
              next: x => {
                const percent = x / item.file.size * 100;
                item.progress = Math.trunc(percent);
                if (item.progress === 100 && !item.uploadCompleted) {
                  this.fileService.confirmUpload(result.id, this.useProxy, this.proxyUserId, this.categoryId).then(() => {
                    item.uploadCompleted = true;
                    subscriptions.push(subscription);
                  }).catch(error => {
                    console.error('Error confirming upload: ', error);
                  });
                }
                if (this.filesToUpload.every(y => y.progress === 100)) {
                  this.allComplete = true;
                  this.uploadsStarted = false;
                  this.dialogRef.close();
                  subscriptions.forEach(x => {
                    x.unsubscribe();
                  });
                }
              },
              error: err => {
                console.error('An error occured: ' + err);
              }
            });
          });
        }
      }
      if (this.fileId && this.fileId.length) {
        for (let item of this.filesToUpload) {
          this.fileUploadService.uploadNewVersion(item, this.fileId, this.useProxy, this.proxyUserId, this.categoryId).then(result => {
            let subscription = this.blobService.upload(result, item.file, {
              onProgress: progress => {
                const percent = progress.loadedBytes / item.file.size * 100;
                item.progress = Math.trunc(percent);
              }
            }).subscribe({
              next: x => {
                const percent = x / item.file.size * 100;
                item.progress = Math.trunc(percent);
                if (item.progress === 100 && !item.uploadCompleted) {
                  this.fileService.confirmUpload(result.id, this.useProxy, this.proxyUserId, this.categoryId).then(() => {
                    item.uploadCompleted = true;
                    subscriptions.push(subscription);
                  }).catch(error => {
                    console.error('Error confirming upload: ', error);
                  });
                }
                if (this.filesToUpload.every(y => y.progress === 100)) {
                  this.allComplete = true;
                  this.uploadsStarted = false;
                  this.dialogRef.close();
                  subscriptions.forEach(x => {
                    x.unsubscribe();
                  });
                }
              },
              error: err => {
                console.error('An error occured: ' + err);
              }
            });
          });
        }
      }
    }
    static {
      this.ɵfac = function FileUploadComponent_Factory(t) {
        return new (t || FileUploadComponent)(i0.ɵɵdirectiveInject(FileUploadService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3$2.MatDialogRef), i0.ɵɵdirectiveInject(BlobService), i0.ɵɵdirectiveInject(FileService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileUploadComponent,
        selectors: [["lib-file-upload"]],
        decls: 17,
        vars: 6,
        consts: [[1, "row", "d-flex", "justify-content-center"], [1, "col-12"], ["class", "dropzone", "fileDragAndDrop", "", 3, "filesChangeEmitter", 4, "ngIf"], [4, "ngIf"], [1, "row", "d-flex", "justify-content-between", "my-3"], [1, "col-6"], ["class", "btn btn-success btn-upload", 3, "click", 4, "ngIf"], ["class", "btn btn-danger btn-upload", 3, "click", 4, "ngIf"], [1, "gap-1"], [1, "row", "mt-3"], [1, "btn", "btn-secondary", 3, "click"], ["fileDragAndDrop", "", 1, "dropzone", 3, "filesChangeEmitter"], [1, "text-wrapper"], [1, "fa-regular", "fa-upload", "upload-icon"], [1, "m-0"], ["type", "file", "name", "file", "id", "file", "multiple", "", 3, "change"], ["for", "file", 1, "mt-3"], [1, "btn", "btn-primary", "text-link"], [1, "warning", "d-flex", "align-items-center"], [2, "padding", "15px"], [1, "far", "fa-exclamation-triangle", "fa-2x"], [2, "padding", "10px"], [1, "mb-1"], [1, "btn", "btn-success", "btn-upload", 3, "click"], [1, "fa-solid", "fa-upload"], [1, "btn", "btn-danger", "btn-upload", 3, "click"], [1, "fa-solid", "fa-times"], [4, "ngFor", "ngForOf"], [1, "row", "m-auto"], [1, "card", "m-1", "w-100"], [1, "card-body", "d-flex", "justify-content-between", "align-items-center"], [1, "file-detail", 2, "width", "260px"], [1, "m-0", "file-detail"], [1, "btn", "btn-danger", "btn-icon-clear", 3, "click"], [1, "fa-solid", "fa-xmark", "fa-lg"], [1, "row", "mb-3"], [1, "d-flex", "justify-content-between", "mt-3", "mb-1"], [1, "upload-file"], ["mode", "determinate", 3, "value", "color"]],
        template: function FileUploadComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-dialog-content")(1, "div", 0)(2, "div", 1);
            i0.ɵɵtemplate(3, FileUploadComponent_div_3_Template, 12, 0, "div", 2)(4, FileUploadComponent_div_4_Template, 10, 0, "div", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
            i0.ɵɵtemplate(7, FileUploadComponent_button_7_Template, 3, 0, "button", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 5);
            i0.ɵɵtemplate(9, FileUploadComponent_button_9_Template, 3, 0, "button", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, FileUploadComponent_div_10_Template, 2, 1, "div", 3)(11, FileUploadComponent_ng_container_11_Template, 2, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "mat-dialog-actions", 8)(13, "div", 9)(14, "div", 1)(15, "button", 10);
            i0.ɵɵlistener("click", function FileUploadComponent_Template_button_click_15_listener() {
              return ctx.closeDialog();
            });
            i0.ɵɵtext(16, "Cancel");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.uploadsStarted);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.uploadsStarted);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.uploadsStarted && ctx.filesToUpload.length > 0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.uploadsStarted && ctx.filesToUpload.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.uploadsStarted);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.uploadsStarted);
          }
        },
        dependencies: [i3$1.NgForOf, i3$1.NgIf, i3$2.MatDialogActions, i3$2.MatDialogContent, i6.MatProgressBar, FileDragAndDropDirective],
        styles: ["#highfield-uploads-shared-file-upload-container[_ngcontent-%COMP%]{height:90px;overflow-wrap:break-word;word-break:break-all}#highfield-uploads-shared-file-upload-container[_ngcontent-%COMP%]   .mat-dialog-content[_ngcontent-%COMP%]{overflow:unset;max-height:500px;min-width:100px}.mat-progress-bar[_ngcontent-%COMP%]{height:30px}.file-select[_ngcontent-%COMP%]{background-color:#f4f4f4;border:1px solid #C8C8C8;border-bottom:none;border-radius:4px 4px 0 0;padding:10px}.selected-files[_ngcontent-%COMP%]{border:1px solid #C8C8C8;border-radius:0 0 4px 4px;padding:10px}.warning[_ngcontent-%COMP%]{padding:5px;background-color:#ffc107;font-weight:500}.btn-icon[_ngcontent-%COMP%]{border-radius:50%;height:35px;width:35px;padding:0}.btn-upload[_ngcontent-%COMP%]{width:100%}.btn-icon-clear[_ngcontent-%COMP%]{border-radius:50%;height:25px;width:25px;padding:0}.dropzone[_ngcontent-%COMP%]{height:220px;display:table;width:100%;background-color:#eee;padding:23px}input[type=file][_ngcontent-%COMP%]{display:none}.text-wrapper[_ngcontent-%COMP%]{text-align:center}.text-link[_ngcontent-%COMP%]{color:#fff;padding:10px 20px;border-radius:25px;cursor:pointer}.upload-icon[_ngcontent-%COMP%]{font-size:4em;margin-bottom:10px;opacity:.2}.file-detail[_ngcontent-%COMP%]{overflow-wrap:break-word;font-weight:500}.upload-file[_ngcontent-%COMP%]{width:400px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"]
      });
    }
  }
  return FileUploadComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilePreviousVersionsComponent = /*#__PURE__*/(() => {
  class FilePreviousVersionsComponent {
    constructor(fileService, userService, data, dialogRef, dateTimeService, loadingService) {
      this.fileService = fileService;
      this.userService = userService;
      this.data = data;
      this.dialogRef = dialogRef;
      this.dateTimeService = dateTimeService;
      this.loadingService = loadingService;
      this.fileVersionDetails = [];
      this.fileId = data.fileId;
    }
    async ngOnInit() {
      this.loadingService.setLoading(true);
      let fileVersions = await this.fileService.getFilePreviousVersions(this.fileId);
      for (let fileVersion of fileVersions) {
        if (fileVersion && fileVersion.uploadedBy) {
          let _uploadedBy = await this.userService.getUserAsync(fileVersion.uploadedBy);
          if (_uploadedBy) {
            fileVersion.uploadedBy = _uploadedBy.FirstName + ' ' + _uploadedBy.LastName;
          }
        }
      }
      this.fileVersionDetails = fileVersions;
      this.loadingService.setLoading(false);
    }
    async downloadPreviousFileVersion(fileId) {
      let result = await this.fileService.downloadFilePreviousVersion(fileId);
      await this.download(result);
    }
    closeDialog() {
      this.dialogRef.close();
    }
    async download(result) {
      if (result) {
        const url = FileService.getFullUrl(result);
        //let blob: Blob = await fetch(url).then(r => r.blob());
        const link = document.createElement("a");
        link.setAttribute('download', 'download');
        link.download = result.filename;
        link.target = "_blank";
        link.href = url; // window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    }
    static {
      this.ɵfac = function FilePreviousVersionsComponent_Factory(t) {
        return new (t || FilePreviousVersionsComponent)(i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3$2.MatDialogRef), i0.ɵɵdirectiveInject(i4$1.DateTimeService), i0.ɵɵdirectiveInject(i3.LoadingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilePreviousVersionsComponent,
        selectors: [["highfield-uploads-shared-file-previous-versions"]],
        decls: 8,
        vars: 1,
        consts: [["mat-dialog-title", ""], ["class", "table table-striped table-border mb-3", 4, "ngFor", "ngForOf"], [1, "btn", "btn-secondary", 3, "click"], [1, "fa-solid", "fa-xmark", "fa-lg"], [1, "table", "table-striped", "table-border", "mb-3"], ["colspan", "2"], ["target", "_blank", 1, "btn", "btn-success", "w-100", 3, "click"], [1, "fas", "fa-file-download"]],
        template: function FilePreviousVersionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 0);
            i0.ɵɵtext(1, "Previous file versions");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "mat-dialog-content");
            i0.ɵɵtemplate(3, FilePreviousVersionsComponent_table_3_Template, 23, 6, "table", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-dialog-actions")(5, "button", 2);
            i0.ɵɵlistener("click", function FilePreviousVersionsComponent_Template_button_click_5_listener() {
              return ctx.closeDialog();
            });
            i0.ɵɵelement(6, "i", 3);
            i0.ɵɵtext(7, "\xA0 Close");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.fileVersionDetails);
          }
        },
        dependencies: [i3$1.NgForOf, i3$2.MatDialogTitle, i3$2.MatDialogActions, i3$2.MatDialogContent, i3$1.DatePipe],
        styles: [".table-border[_ngcontent-%COMP%]{border-bottom:2px solid #ccc}"]
      });
    }
  }
  return FilePreviousVersionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let YesNoDialogComponent = /*#__PURE__*/(() => {
  class YesNoDialogComponent {
    constructor(data, dialogRef, router) {
      this.data = data;
      this.dialogRef = dialogRef;
      this.router = router;
    }
    ngOnInit() {}
    submit() {
      this.dialogRef.close(true);
    }
    cancel() {
      this.dialogRef.close(false);
    }
    static {
      this.ɵfac = function YesNoDialogComponent_Factory(t) {
        return new (t || YesNoDialogComponent)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3$2.MatDialogRef), i0.ɵɵdirectiveInject(i1$2.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: YesNoDialogComponent,
        selectors: [["lib-yes-no-dialog"]],
        decls: 7,
        vars: 1,
        consts: [["mat-dialog-title", "", 3, "innerHTML"], [1, "gap-1"], ["type", "button", 1, "button", "btn", "btn-success", 3, "click"], ["type", "button", 1, "button", "btn", "btn-danger", 3, "click"]],
        template: function YesNoDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "h2", 0)(1, "mat-dialog-content");
            i0.ɵɵelementStart(2, "mat-dialog-actions", 1)(3, "button", 2);
            i0.ɵɵlistener("click", function YesNoDialogComponent_Template_button_click_3_listener() {
              return ctx.submit();
            });
            i0.ɵɵtext(4, "Yes");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "button", 3);
            i0.ɵɵlistener("click", function YesNoDialogComponent_Template_button_click_5_listener() {
              return ctx.cancel();
            });
            i0.ɵɵtext(6, "No");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("innerHTML", ctx.data.message, i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i3$2.MatDialogTitle, i3$2.MatDialogActions, i3$2.MatDialogContent]
      });
    }
  }
  return YesNoDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UploadedFilesComponent = /*#__PURE__*/(() => {
  class UploadedFilesComponent {
    constructor(fileService, treeListService, loadingService, blobService, dialog, folderDownloadService) {
      this.fileService = fileService;
      this.treeListService = treeListService;
      this.loadingService = loadingService;
      this.blobService = blobService;
      this.dialog = dialog;
      this.folderDownloadService = folderDownloadService;
      this.nodeCountChanged = new EventEmitter();
      this.uploadSummary = [];
      this.loading = false;
      this.isSelectionEmpty = true;
    }
    ngOnDestroy() {
      this.treeListSub.unsubscribe();
    }
    async ngOnChanges() {
      this.parentId = this.linkId;
      await this.refreshFiles();
    }
    async ngOnInit() {
      this.treeListSub = this.treeListService.actionClick$.subscribe(action => this.handleActionSubscription(action));
      this.parentId = this.linkId;
      this.flattenStructure();
      of(this.setBreadCrumbs(this.parentId)).subscribe(async () => {
        if (this.breadCrumbs.length > 0) {
          await this.refreshFiles();
        }
      });
      this.treeListService.selectedIdClick$.subscribe(async val => {
        /*this.selectedNodes = val;*/
        this.selectedNodes = val || [];
        this.isSelectionEmpty = this.selectedNodes.length === 0;
      });
    }
    setBreadCrumbs(parentId) {
      this.crumbs = [];
      of(this.buildBreadCrumb(parentId)).subscribe(() => {
        this.breadCrumbs = [];
        this.breadCrumbs = this.crumbs;
      });
    }
    enableButtonOnSelected() {
      return !this.nodes || !this.nodes.some(node => node && node.selected);
    }
    deleteSelectedFiles() {
      this.deleteSelected(this.selectedNodes);
    }
    downloadSelectedFiles() {
      this.downloadSelected(this.selectedNodes);
    }
    onOpenFolder(id) {
      this.parentId = id.toString();
      this.fileId = undefined;
      this.crumbs = [];
      of(this.setBreadCrumbs(this.parentId)).subscribe(async () => {
        if (!(this.breadCrumbs.length < 0)) {
          await this.refreshFiles();
        }
      });
    }
    refreshFiles() {
      this.loading = true;
      console.log("Refreshing");
      from(this.fileService.getUploadedFiles({
        categoryId: this.categoryId,
        linkId: this.parentId
      }, this.useProxy, this.proxyUserId, this.categoryId)).subscribe(files => {
        this.nodes = [];
        this.loading = true;
        //this.loadingService.setLoading(true);
        of(this.setNodes(files)).subscribe(() => {
          this.loading = false;
          //this.loadingService.setLoading(false);
          if (this.nodes?.length > 0) {
            this.nodeCountChanged.emit(this.nodes.length);
          }
        });
      });
    }
    onAddFile(fileLinkId, fileCategoryId) {
      if (this.linkId !== fileLinkId) {
        fileCategoryId = null;
      }
      const dialogRef = this.dialog.open(FileUploadComponent, {
        data: {
          linkId: fileLinkId,
          categoryId: fileCategoryId,
          fileId: null,
          newFile: true,
          useProxy: this.useProxy,
          proxyUserId: this.proxyUserId
        },
        disableClose: true,
        minHeight: '300px',
        width: "600px"
      });
      dialogRef.afterClosed().subscribe(() => {
        this.loadingService.setLoading(true);
        this.refreshFiles();
        this.loadingService.setLoading(false);
      });
    }
    onNewVersion(fileId) {
      const dialogRef = this.dialog.open(FileUploadComponent, {
        data: {
          linkId: null,
          categoryId: null,
          fileId: fileId,
          newFile: false,
          useProxy: this.useProxy,
          proxyUserId: this.proxyUserId
        },
        disableClose: true,
        minHeight: '300px',
        width: "600px"
      });
      dialogRef.afterClosed().subscribe(() => {
        this.refreshFiles();
      });
    }
    onDetails(fileId) {
      this.fileId = undefined;
      this.fileId = fileId;
      // this.dialog.open(FileDetailsComponent, { data: { linkId: null, categoryId: null, fileId: fileId }, disableClose: true, height: "300px", minWidth: "500px" });
    }
    onShowPreviousVersions(fileId) {
      this.dialog.open(FilePreviousVersionsComponent, {
        data: {
          linkId: null,
          categoryId: null,
          fileId: fileId
        },
        disableClose: false,
        minWidth: "550px"
      });
    }
    onAddFolder(folderLinkId, fileCategoryId) {
      if (this.linkId !== folderLinkId) {
        fileCategoryId = null;
      }
      const dialogRef = this.dialog.open(AddFolderComponent, {
        data: {
          linkId: folderLinkId,
          categoryId: fileCategoryId,
          fileId: null
        },
        disableClose: true,
        width: "600px"
      });
      dialogRef.afterClosed().subscribe(async value => {
        this.loadingService.setLoading(true);
        this.loading = true;
        if (value.event) {
          await this.flattenStructure();
          await this.refreshFiles();
        }
        this.loading = false;
        this.loadingService.setLoading(false);
      });
    }
    async onDeleteFolder(folderId) {
      this.loading = true;
      from(this.onDeleteFiles(folderId)).pipe(switchMap(() => {
        return this.fileService.deleteEntity(folderId, this.useProxy, this.proxyUserId, this.categoryId);
      })).subscribe(() => {
        this.refreshFiles();
      });
      this.loading = false;
      //this.loadingService.setLoading(false);
    }
    async onDeleteFiles(fileId) {
      this.loading = true;
      const info = await this.fileService.deleteFileInfo(fileId, this.useProxy, this.proxyUserId, this.categoryId);
      for (const fileInfo of info) {
        if (fileInfo.deletePath) {
          try {
            await this.blobService.delete(fileInfo);
          } catch (ex) {
            console.log(ex.message);
          } finally {
            await this.fileService.deleteVersion(fileInfo.entityId, this.useProxy, this.proxyUserId, this.categoryId);
          }
        } else {
          await this.fileService.deleteEntity(fileInfo.entityId, this.useProxy, this.proxyUserId, this.categoryId);
        }
      }
      this.refreshFiles();
      this.loading = false;
    }
    async download(result) {
      if (result) {
        streamSaver.mitm = 'https://highfieldcdnstorage.blob.core.windows.net/resources/html/mitm.html';
        const url = (await fetch(FileService.getFullUrl(result))).body;
        var fileStream = streamSaver.createWriteStream(`${result.filename}`);
        // Modern implementation
        if (window.WritableStream && !!url.pipeTo) {
          return url.pipeTo(fileStream).then(() => console.log('done writing'));
        }
        // Backup for older browsers
        const writer = fileStream.getWriter();
        const reader = url.getReader();
        const pump = () => reader.read().then(res => res.done ? writer.close() : writer.write(res.value).then(pump));
        pump();
      }
    }
    async onDownloadAllZip(fileLinkId, fileCategoryId) {
      this.loading = true;
      let name = this.flatStructure.find(x => x.id === fileLinkId)?.name !== undefined ? this.flatStructure.find(x => x.id === fileLinkId)?.name : "information resources";
      await this.fileService.getUploadedFiles({
        categoryId: fileCategoryId ?? this.categoryId,
        linkId: fileLinkId
      }, this.useProxy, this.proxyUserId, this.categoryId).then(async val => {
        await this.folderDownloadService.downloadZip(name, val);
        this.folderDownloadService.loading$.subscribe(val => {
          this.loading = val;
        });
      });
    }
    async downloadSelected(fileIdList) {
      const zipFileName = `selected_files_${new Date().toISOString()}`;
      this.loading = true;
      await this.fileService.getUploadedFilesbyIds(fileIdList).then(async val => {
        await this.folderDownloadService.downloadZip(zipFileName, val);
      });
      this.folderDownloadService.loading$.subscribe(val => {
        this.loading = val;
      });
    }
    async deleteSelected(fileIdList) {
      this.dialog.open(YesNoDialogComponent, {
        data: {
          message: 'Are you sure that you want to delete these files?'
        }
      }).afterClosed().subscribe(answer => {
        if (answer) {
          fileIdList.forEach(i => {
            this.onDeleteFiles(i);
          });
        }
      });
    }
    async handleActionSubscription(val) {
      if (val) {
        let result;
        this.fileId = undefined;
        switch (val.action) {
          case 'Download':
            result = await this.fileService.downloadFile(val.id, this.useProxy, this.proxyUserId, this.categoryId);
            await this.download(result);
            break;
          case 'Add File':
            await this.onAddFile(val.id, null);
            break;
          case 'Play Audio':
            if (window.location.pathname.toLowerCase().indexOf('embedded') > -1) {
              window.open(`${window.location.protocol}//${window.location.host}/embedded/audio/${val.id}`, '_blank');
            } else {
              window.open(`${window.location.protocol}//${window.location.host}/audio/${val.id}`, '_blank');
            }
            break;
          case 'Play Video':
            if (window.location.pathname.toLowerCase().indexOf('embedded') > -1) {
              window.open(`${window.location.protocol}//${window.location.host}/embedded/video/${val.id}`, '_blank');
            } else {
              window.open(`${window.location.protocol}//${window.location.host}/video/${val.id}`, '_blank');
            }
            break;
          case 'Add Folder':
            await this.onAddFolder(val.id, null);
            break;
          case 'Upload New Version':
            await this.onNewVersion(val.id);
            break;
          case "View Previous Versions":
            await this.onShowPreviousVersions(val.id);
            break;
          case 'View Image':
            result = await this.fileService.downloadFile(val.id, this.useProxy, this.proxyUserId, this.categoryId);
            this.fileService.incrementDownloads(result.id, this.useProxy, this.proxyUserId, this.categoryId);
            if (result) {
              window.open(FileService.getFullUrl(result), '_blank');
            }
            break;
          case 'Open Folder':
            this.onOpenFolder(val.id);
            break;
          case 'Download All':
            this.onDownloadAllZip(val.id, null);
            break;
          case 'Delete Contents':
            this.dialog.open(YesNoDialogComponent, {
              data: {
                message: 'Are you sure that you want to delete the contents of this folder?'
              }
            }).afterClosed().subscribe(answer => {
              if (answer) {
                this.onDeleteFiles(val.id);
              }
            });
            break;
          case 'Delete Folder':
            this.dialog.open(YesNoDialogComponent, {
              data: {
                message: 'Are you sure that you want to delete this folder?'
              }
            }).afterClosed().subscribe(answer => {
              if (answer) {
                this.onDeleteFolder(val.id);
              }
            });
            break;
          case 'Delete File':
            this.dialog.open(YesNoDialogComponent, {
              data: {
                message: 'Are you sure that you want to delete this file?'
              }
            }).afterClosed().subscribe(answer => {
              if (answer) {
                this.onDeleteFiles(val.id);
              }
            });
            break;
          //case 'Details':
          //  await this.onDetails(val.id);
          //  break;
        }
      }
    }
    setChildModeOptions(children) {
      let node;
      for (node of children) {
        node.icon = node.type.hasChildren ? 'far fa-folder' : 'far fa-file';
        node.actions = this.setActions(node);
        node.children = this.setChildModeOptions(node.children);
      }
      return children;
    }
    setActions(entity) {
      let actions = [];
      actions = entity.fileType?.downloadOptions?.map(o => o.downloadOptionName) == undefined ? actions : actions.concat(entity.fileType?.downloadOptions?.map(o => o.downloadOptionName));
      if (entity.type) {
        if (entity.type.hasChildren) {
          actions.push('Open Folder');
          if (this.configuration.showAddFileButton) actions.push('Add File');
          if (this.configuration.showCreateFolderButton) actions.push('Add Folder');
          if (this.configuration.showDownloadButton) actions.push('Download All');
          if (this.configuration.showDeleteButton) {
            actions.push('Delete Contents');
            actions.push('Delete Folder');
          }
        } else {
          if (this.configuration.showDeleteButton) actions.push('Delete File');
        }
        if (entity.type.hasVersions) {
          if (this.configuration.showAddFileButton) actions.push('Upload New Version');
          if (entity.versionCount > 1) actions.push("View Previous Versions");
        }
      }
      return actions;
    }
    setNodes(files) {
      this.nodes = files.map(f => {
        return {
          id: f.id,
          name: f.name,
          icon: f.type.hasChildren ? 'fa-solid fa-folder fa-xl' : this.setFileIcon(f.fileType.mimePrefix),
          children: this.setChildModeOptions(f.children),
          actions: this.setActions(f),
          versionCount: f.versionCount,
          uploadedByName: f.uploadedByName,
          lastUploadedDate: f.lastUploadedDate
        };
      });
    }
    setFileIcon(fileType) {
      switch (fileType) {
        case 'audio':
          return 'fa-solid fa-volume fa-xl';
        case 'image':
          return 'fa-solid fa-image fa-xl';
        case 'video':
          return 'fa-solid fa-video fa-xl';
        case 'text':
          return 'fa-solid fa-file-lines fa-xl';
        default:
          return 'fa-solid fa-file fa-xl';
      }
    }
    async flattenStructure() {
      this.flatStructure = [];
      this.uploadSummary = await this.fileService.getUploadedFiles({
        categoryId: this.categoryId,
        linkId: this.linkId
      }, this.useProxy, this.proxyUserId, this.categoryId);
      of(this.uploadSummary).subscribe(files => {
        from(files.filter(item => item.type.hasChildren)).pipe(expand(x => {
          return x.children && x.children.length ? from(x.children) : EMPTY;
        }), map(y => ({
          id: y.id,
          linkId: y.linkId,
          name: y.name,
          type: y.type
        })), toArray()).subscribe(data => {
          this.flatStructure = data;
        });
      });
    }
    buildBreadCrumb(parentId) {
      if (!Array.isArray(this.flatStructure) || this.flatStructure.length < 0) {
        of(this.flattenStructure).subscribe();
      }
      let summary = this.flatStructure.find(x => x.id.toLowerCase() === parentId.toLowerCase());
      if (summary === undefined) {
        of(this.flattenStructure).subscribe(() => {
          summary = this.flatStructure.find(x => x.id.toLowerCase() === parentId.toLowerCase());
        });
      }
      if (summary) {
        if (this.crumbs === undefined) {
          this.crumbs = new Array();
        }
        let link = {
          id: summary.id,
          parentId: summary.linkId,
          name: summary.name !== 'undefined' && summary.name.length > 50 ? summary.name.slice(0, 50) + '...' : summary.name
        };
        this.crumbs.push(link);
        this.buildBreadCrumb(summary.linkId);
      } else {
        let link = {
          id: parentId,
          parentId: '',
          name: ''
        };
        this.crumbs.push(link);
      }
    }
    responsiveClass() {
      if (this.fileId !== undefined) {
        return "col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-8 col-xs-8";
      } else {
        return "col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8";
      }
    }
    static {
      this.ɵfac = function UploadedFilesComponent_Factory(t) {
        return new (t || UploadedFilesComponent)(i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(TreeListService), i0.ɵɵdirectiveInject(i3.LoadingService), i0.ɵɵdirectiveInject(BlobService), i0.ɵɵdirectiveInject(i3$2.MatDialog), i0.ɵɵdirectiveInject(FolderDownloadService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UploadedFilesComponent,
        selectors: [["highfield-uploads-shared-uploaded-files"]],
        inputs: {
          linkId: "linkId",
          categoryId: "categoryId",
          useProxy: "useProxy",
          proxyUserId: "proxyUserId",
          configuration: "configuration"
        },
        outputs: {
          nodeCountChanged: "nodeCountChanged"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: TreeListService,
          useFactory: () => new TreeListService()
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 12,
        vars: 7,
        consts: [[1, "container-fluid"], ["class", "col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-8"], [1, "my-3"], ["class", "btn btn-primary me-2", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn btn-primary me-2", 3, "disabled", "click", 4, "ngIf"], ["class", "btn btn-danger btn btn-primary me-2", 3, "disabled", "click", 4, "ngIf"], [1, "row"], [1, "col-12"], ["id", "highfield-uploads-shared-uploaded-files-container"], [4, "ngIf"], [1, "col-xxl-8", "col-xl-8", "col-lg-8", "col-md-8", "col-sm-8", "col-xs-8"], ["class", "ml-1", 4, "ngIf"], [1, "ml-1"], ["class", "btn btn-link mt-3 p-0", 3, "click", 4, "ngFor", "ngForOf"], [1, "btn", "btn-link", "mt-3", "p-0", 3, "click"], [3, "ngClass"], [1, "fas", "fa-chevron-right", "mx-3"], [1, "btn", "btn-primary", "me-2", 3, "click"], [1, "fa-solid", "fa-file-plus", "fa-lg"], [1, "fa-solid", "fa-folder-plus", "fa-lg"], [1, "btn", "btn-primary", "btn", "btn-primary", "me-2", 3, "disabled", "click"], [1, "btn", "btn-danger", "btn", "btn-primary", "me-2", 3, "disabled", "click"], [3, "nodes", "configuration"], [1, "loading-container"], [1, "spinner"]],
        template: function UploadedFilesComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, UploadedFilesComponent_Conditional_1_Template, 2, 1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, UploadedFilesComponent_button_3_Template, 3, 0, "button", 3)(4, UploadedFilesComponent_button_4_Template, 3, 0, "button", 3)(5, UploadedFilesComponent_button_5_Template, 2, 1, "button", 4)(6, UploadedFilesComponent_button_6_Template, 2, 1, "button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8);
            i0.ɵɵtemplate(10, UploadedFilesComponent_ng_container_10_Template, 2, 2, "ng-container", 9);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(11, UploadedFilesComponent_div_11_Template, 3, 0, "div", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.configuration.showBreadCrumbs ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.configuration.showAddFileButton);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.configuration.showCreateFolderButton);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.configuration.showDownloadButton);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.configuration.showDeleteButton);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.nodes && ctx.nodes.length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.loading);
          }
        },
        dependencies: [i3$1.NgClass, i3$1.NgForOf, i3$1.NgIf, i8.MatProgressSpinner, TreeListComponent],
        styles: ["#highfield-uploads-shared-uploaded-files-container[_ngcontent-%COMP%]{height:calc(100% - 50px);width:100%}#highfield-uploads-shared-file-details-container[_ngcontent-%COMP%]{height:calc(100% - 50px);border:5px solid #ddd;border-radius:5px;background-color:#fff;padding:25px}.btn-link[_ngcontent-%COMP%]{padding-right:0;padding-left:6px}.container[_ngcontent-%COMP%], .container-lg[_ngcontent-%COMP%], .container-md[_ngcontent-%COMP%], .container-sm[_ngcontent-%COMP%], .container-xl[_ngcontent-%COMP%]{margin-left:0!important}.loading-container[_ngcontent-%COMP%]{height:100vh;width:100vw;display:flex;justify-content:center;align-items:center;position:absolute;top:0;left:0;z-index:99;background-color:#fff;opacity:.9}"]
      });
    }
  }
  return UploadedFilesComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FileUploadConfig {
  constructor() {
    this.showAddFileButton = true;
    this.showDownloadButton = true;
    this.showCreateFolderButton = true;
    this.showDeleteButton = true;
    this.showVersionColumn = true;
    this.showTypeColumn = true;
    this.showUploadedByColumn = true;
    this.showUploadedDateColumn = true;
    this.showActionColumn = true;
    this.showBreadCrumbs = true;
  }
}
function convertReadonly(config, readonly) {
  const isEditable = readonly === "0";
  config.showAddFileButton = isEditable;
  config.showCreateFolderButton = isEditable;
  config.showDeleteButton = isEditable;
}
let ManageComponent = /*#__PURE__*/(() => {
  class ManageComponent {
    constructor(route, router, location) {
      this.route = route;
      this.router = router;
      this.uploadConfig = new FileUploadConfig();
      this.loaded = false;
      this.navigationSubscription = this.router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          if (this.loaded) {
            this.child.ngOnChanges();
          }
        }
      });
      this.location = location;
    }
    ngOnInit() {
      this.loaded = false;
      this.route.data.subscribe(({
        access
      }) => {
        this.linkId = access.linkId;
        this.categoryId = access.categoryId;
        convertReadonly(this.uploadConfig, access.readonly);
      });
      this.loaded = true;
    }
    ngOnDestroy() {
      if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function ManageComponent_Factory(t) {
        return new (t || ManageComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i3$1.Location));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ManageComponent,
        selectors: [["lib-manage"]],
        viewQuery: function ManageComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(UploadedFilesComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.child = _t.first);
          }
        },
        features: [i0.ɵɵProvidersFeature([Location, {
          provide: LocationStrategy,
          useClass: PathLocationStrategy
        }])],
        decls: 4,
        vars: 3,
        consts: [["id", "highfield-cdn-admin-manage-container"], [1, "row", "h-25"], [1, "row"], [3, "linkId", "categoryId", "configuration"]],
        template: function ManageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "highfield-uploads-shared-uploaded-files", 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("linkId", ctx.linkId);
            i0.ɵɵpropertyInterpolate("categoryId", ctx.categoryId);
            i0.ɵɵproperty("configuration", ctx.uploadConfig);
          }
        },
        dependencies: [UploadedFilesComponent],
        styles: ["#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]{background-color:#fff;margin-right:2vw!important;padding:20px}#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%] > .row[_ngcontent-%COMP%]{width:80vw}"]
      });
    }
  }
  return ManageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageAccessResolver$1 = class PageAccessResolver {
  resolve(route, state) {
    return of({
      linkId: "39C9B4D1-974D-42A4-9F9C-2E21A491BA94",
      categoryId: "8290C34D-8680-46AE-9EAC-E6ACF5B178D5",
      readonly: "0"
    });
  }
  static {
    this.ɵfac = function PageAccessResolver_Factory(t) {
      return new (t || PageAccessResolver)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PageAccessResolver,
      factory: PageAccessResolver.ɵfac,
      providedIn: 'root'
    });
  }
};
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlayVideoComponent = /*#__PURE__*/(() => {
  class PlayVideoComponent {
    constructor(route, fileService) {
      this.route = route;
      this.fileService = fileService;
    }
    async ngOnInit() {
      const id = this.route.snapshot.params["id"];
      const result = await this.fileService.downloadFile(id);
      this.url = FileService.getFullUrl(result);
    }
    static {
      this.ɵfac = function PlayVideoComponent_Factory(t) {
        return new (t || PlayVideoComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(FileService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PlayVideoComponent,
        selectors: [["highfield-uploads-play-video"]],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["autoplay", "", "controls", ""], ["type", "video/mp4", 3, "src"]],
        template: function PlayVideoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PlayVideoComponent_ng_container_0_Template, 4, 1, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.url);
          }
        },
        dependencies: [i3$1.NgIf]
      });
    }
  }
  return PlayVideoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlayAudioComponent = /*#__PURE__*/(() => {
  class PlayAudioComponent {
    constructor(route, fileService) {
      this.route = route;
      this.fileService = fileService;
    }
    async ngOnInit() {
      const id = this.route.snapshot.params["id"];
      const result = await this.fileService.downloadFile(id);
      this.fileService.incrementDownloads(result.id);
      this.audioUrl = FileService.getFullUrl(result);
      this.audioMimeType = result.mimeType;
    }
    static {
      this.ɵfac = function PlayAudioComponent_Factory(t) {
        return new (t || PlayAudioComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(FileService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PlayAudioComponent,
        selectors: [["highfield-uploads-play-audio"]],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], ["autoplay", "", "controls", ""], [3, "src", "type"]],
        template: function PlayAudioComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PlayAudioComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.audioUrl);
          }
        },
        dependencies: [i3$1.NgIf]
      });
    }
  }
  return PlayAudioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const adminRoutes = [{
  path: "",
  redirectTo: 'manage',
  pathMatch: 'full'
}, {
  path: "overview",
  component: OverviewComponent
}, {
  path: 'manage',
  component: ManageComponent,
  resolve: {
    access: PageAccessResolver$1
  }
}, {
  path: "video/:id",
  component: PlayVideoComponent
}, {
  path: "audio/:id",
  component: PlayAudioComponent
}];
let AdminRoutingModule = /*#__PURE__*/(() => {
  class AdminRoutingModule {
    static {
      this.ɵfac = function AdminRoutingModule_Factory(t) {
        return new (t || AdminRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AdminRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild(adminRoutes), RouterModule]
      });
    }
  }
  return AdminRoutingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileUploadMultipleComponent = /*#__PURE__*/(() => {
  class FileUploadMultipleComponent {
    constructor(router, blobService, fileService, data) {
      this.router = router;
      this.blobService = blobService;
      this.fileService = fileService;
      this.data = data;
      this.filesToUpload = [];
      this.allComplete = false;
      this.uploadsStarted = false;
      this.newFile = true;
      this.linkId = data.linkId;
      this.categoryId = data.categoryId;
      this.fileId = data.fileId;
      this.newFile = data.newFile;
      router.events.subscribe(event => {
        if (event instanceof NavigationStart) {}
      });
    }
    onBeforeUnload($event) {
      if (this.uploadsStarted == true && this.allComplete == false) {
        $event.preventDefault();
        $event.returnValue = 'You currently have files uploading. Closing the browser may result in these files being lost.';
      }
    }
    ngAfterViewInit() {
      this.allComplete = false;
      this.uploadsStarted = false;
      const toolbars = document.getElementsByClassName('ui-fileupload-buttonbar');
      const toolbar = toolbars.item(0);
      this.setStylesUploadBtn(toolbar);
      this.setStylesClearFileListBtn(toolbar);
    }
    handleFilesInput(files) {
      let filesNames = '';
      for (var i = 0; i < files.length; i++) {
        this.filesToUpload.push({
          file: files[i],
          progress: 0,
          uploadCompleted: false
        });
        filesNames.concat(`"${files[i].name}" `);
      }
    }
    async primeUploadHandler(event, primeUpload) {
      this.handleFilesInput(event.files);
      primeUpload.clear();
      await this.upload(primeUpload);
    }
    primeFilesSelected(event, primeUpload) {
      this.filesToUpload = [];
      this.allComplete = false;
    }
    async upload(primeUpload) {
      this.uploadsStarted = true;
      const uploadTasks = [];
      if (this.linkId && this.linkId.length) {
        for (let item of this.filesToUpload) {
          uploadTasks.push(this.uploadNewFile(item));
        }
      }
      if (this.fileId && this.fileId.length) {
        for (let item of this.filesToUpload) {
          uploadTasks.push(this.uploadNewVersion(item));
        }
      }
      if (uploadTasks.length > 0) {
        Promise.all(uploadTasks).then(values => {
          this.allComplete = true;
          this.uploadsStarted = false;
        });
      } else {
        this.allComplete = true;
        this.uploadsStarted = false;
      }
    }
    async uploadNewFile(fileToUpload) {
      const upload = new NewUpload();
      upload.typeId = '5B88CEB4-FCD7-43B8-9608-A9DB372A69D4';
      upload.linkId = this.linkId;
      upload.categoryId = this.categoryId;
      if (fileToUpload.file.name.lastIndexOf(".") > -1 == true) {
        upload.title = fileToUpload.file.name.substring(0, fileToUpload.file.name.lastIndexOf("."));
      } else {
        upload.title = fileToUpload.file.name;
      }
      upload.description = '';
      upload.filename = fileToUpload.file.name;
      upload.mimeType = fileToUpload.file.type;
      const result = await this.fileService.uploadFile(upload);
      // await this.blobService.upload(result,
      //   fileToUpload.file,
      //   {
      //     onProgress: (progress: TransferProgressEvent) => {
      //       const percent = (progress.loadedBytes / fileToUpload.file.size) * 100;
      //       fileToUpload.progress = Math.trunc(percent);
      //     }
      //   });
      await this.fileService.confirmUpload(result.id);
    }
    async uploadNewVersion(fileToUpload) {
      const upload = new NewUploadVersion();
      upload.entityId = this.fileId;
      upload.filename = fileToUpload.file.name;
      upload.mimeType = fileToUpload.file.type;
      const result = await this.fileService.uploadFileVersion(upload);
      // await this.blobService.upload(result,
      //   fileToUpload.file,
      //   {
      //     onProgress: (progress: TransferProgressEvent) => {
      //       const percent = (progress.loadedBytes / fileToUpload.file.size) * 100;
      //       fileToUpload.progress = Math.trunc(percent);
      //     }
      //   });
      await this.fileService.confirmUpload(result.id);
    }
    setStylesUploadBtn(toolbar) {
      const pbutton = toolbar?.children.item(1);
      const button = pbutton?.children.item(0);
      button?.classList.add('ui-button-success');
    }
    setStylesClearFileListBtn(toolbar) {
      const pbutton = toolbar?.children.item(2);
      const button = pbutton?.children.item(0);
      button?.classList.add('ui-button-danger');
    }
    static {
      this.ɵfac = function FileUploadMultipleComponent_Factory(t) {
        return new (t || FileUploadMultipleComponent)(i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(BlobService), i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileUploadMultipleComponent,
        selectors: [["highfield-uploads-shared-file-upload-multiple"]],
        hostBindings: function FileUploadMultipleComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("beforeunload", function FileUploadMultipleComponent_beforeunload_HostBindingHandler($event) {
              return ctx.onBeforeUnload($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        decls: 6,
        vars: 2,
        consts: [["id", "highfield-uploads-shared-file-upload-container"], ["mat-dialog-content", ""], ["mat-dialog-actions", ""], ["class", "UploadComplete", 4, "ngIf"], ["class", "ui-button-danger", "icon", "fa fa-times", "label", "Close", "mat-button", "", "mat-dialog-close", "", 4, "ngIf"], [1, "UploadComplete"], ["icon", "fa fa-times", "label", "Close", "mat-button", "", "mat-dialog-close", "", 1, "ui-button-danger"]],
        template: function FileUploadMultipleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, FileUploadMultipleComponent_span_3_Template, 2, 0, "span", 3);
            i0.ɵɵelement(4, "br");
            i0.ɵɵtemplate(5, FileUploadMultipleComponent_highfieldlayout_button_5_Template, 1, 0, "highfieldlayout-button", 4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.allComplete);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.allComplete == true || ctx.uploadsStarted == false);
          }
        },
        dependencies: [i3$1.NgIf, i3$2.MatDialogClose, i3$2.MatDialogActions, i3$2.MatDialogContent],
        styles: ["#highfield-uploads-shared-file-upload-container{height:100%}.mat-dialog-content{height:calc(100% - 52px)}.mat-dialog-actions{height:52px}.hide-text{color:transparent}.ui-fileupload-content .ui-fileupload-row .ui-progressbar{position:relative!important;width:100px!important;height:25px!important}.UploadComplete{width:100%;text-align:center;font-weight:700}\n"],
        encapsulation: 2
      });
    }
  }
  return FileUploadMultipleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileDetailsComponent = /*#__PURE__*/(() => {
  class FileDetailsComponent {
    constructor(fileService, userService, data, dialogRef, dateTimeService, loadingService) {
      this.fileService = fileService;
      this.userService = userService;
      this.data = data;
      this.dialogRef = dialogRef;
      this.dateTimeService = dateTimeService;
      this.loadingService = loadingService;
      this.fileId = data.fileId;
    }
    async ngOnInit() {
      let fileDetails = await this.fileService.getFileDetails(this.fileId);
      if (fileDetails && fileDetails.uploadedBy) {
        let _uploadedBy = await this.userService.getUserAsync(fileDetails.uploadedBy);
        if (_uploadedBy) {
          fileDetails.uploadedBy = _uploadedBy.FirstName + ' ' + _uploadedBy.LastName;
        }
      }
      this.displayFileDetails = fileDetails;
    }
    static {
      this.ɵfac = function FileDetailsComponent_Factory(t) {
        return new (t || FileDetailsComponent)(i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i3$2.MatDialogRef), i0.ɵɵdirectiveInject(i4$1.DateTimeService), i0.ɵɵdirectiveInject(i3.LoadingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileDetailsComponent,
        selectors: [["highfield-uploads-shared-file-details"]],
        decls: 1,
        vars: 1,
        consts: [["id", "highfield-uploads-shared-file-details-container", 4, "ngIf"], ["id", "highfield-uploads-shared-file-details-container"], ["mat-dialog-title", ""], ["mat-dialog-content", ""], [1, "row"], [1, "col-4", 2, "white-space", "nowrap"], [1, "col-8"], ["mat-dialog-actions", ""], ["icon", "fa fa-times", "label", "Close", "mat-button", "", "mat-dialog-close", "", 1, "ui-button-danger"]],
        template: function FileDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FileDetailsComponent_div_0_Template, 36, 6, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.displayFileDetails);
          }
        },
        dependencies: [i3$1.NgIf, i3$2.MatDialogClose, i3$2.MatDialogTitle, i3$2.MatDialogActions, i3$2.MatDialogContent],
        styles: ["#highfield-uploads-shared-file-upload-container[_ngcontent-%COMP%]{height:50px}"]
      });
    }
  }
  return FileDetailsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileDetailsSideViewComponent = /*#__PURE__*/(() => {
  class FileDetailsSideViewComponent {
    constructor(fileService, userService, loadingService) {
      this.fileService = fileService;
      this.userService = userService;
      this.loadingService = loadingService;
      this.downloadLink = '';
      this.fileIcon = '';
      this.copyText = " Copy link";
    }
    async ngOnChanges() {
      if (this.fileId !== undefined) {
        let fileDetails = await this.fileService.getFileDetails(this.fileId.toString());
        this.fileIcon = this.getFileIcon(fileDetails.mimeType);
        let downlodedFile = await this.fileService.downloadFile(this.fileId.toString());
        this.downloadLink = FileService.getFullUrl(downlodedFile);
        if (fileDetails && fileDetails.uploadedBy) {
          let _uploadedBy = await this.userService.getUserAsync(fileDetails.uploadedBy);
          if (_uploadedBy) {
            fileDetails.uploadedBy = _uploadedBy.FirstName + ' ' + _uploadedBy.LastName;
          }
        }
        this.displayFileDetails = fileDetails;
      }
    }
    getFileIcon(mimeType) {
      let extentions = mimeType.split('/');
      if (extentions[0].startsWith("application")) {
        switch (extentions[1]) {
          case "msword":
          case "vnd.openxmlformats-officedocument.wordprocessingml.document":
          case "vnd.oasis.opendocument.text":
            return "fa-regular fa-file-word fa-lg";
          case "pdf":
            return "fa-regular fa-file-pdf fa-lg";
          case "vnd.ms-excel":
          case "vnd.oasis.opendocument.spreadsheet":
          case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return "fa-regular fa-file-powerpoint fa-lg";
          case "zip":
          case "x-zip-compressed":
            return "fa-regular fa-file-zip fa-lg";
          default:
            return "fa-regular fa-file fa-lg";
        }
      } else {
        switch (extentions[0]) {
          case "audio":
            return "fa-regular fa-volume fa-lg";
          case "image":
            return "fa-regular fa-image fa-lg";
          case "video":
            return "fa-regular fa-video fa-lg";
          case "text":
            return "fa-regular fa-file-lines fa-lg";
          default:
            return "fa-regular fa-file fa-lg";
        }
      }
    }
    downloadFile(fileId) {
      this.fileService.incrementDownloads(fileId);
    }
    onClipboardCopy(successful) {
      if (successful) {
        this.copyText = " Link Copied";
        setTimeout(() => {
          this.copyText = " Copy Link";
        }, 5000);
      }
    }
    static {
      this.ɵfac = function FileDetailsSideViewComponent_Factory(t) {
        return new (t || FileDetailsSideViewComponent)(i0.ɵɵdirectiveInject(FileService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.LoadingService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileDetailsSideViewComponent,
        selectors: [["lib-file-details-side-view"]],
        inputs: {
          fileId: "fileId"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 1,
        consts: [["id", "highfield-uploads-shared-file-details-side-view-container", 4, "ngIf"], ["id", "highfield-uploads-shared-file-details-side-view-container"], [1, "my-3"], [1, "row"], [1, "table", "table-striped"], [1, "cell-1"], [1, "col-xxl-4", "col-xl-4", "col-lg-4", "col-md-12", "col-sm-12", "p-0", "detals"], [1, "btn", "btn-light", "me-1", "mb-1", 3, "cdkCopyToClipboard", "cdkCopyToClipboardCopied"], [1, "fa-regular", "fa-link", "fa-lg"], ["target", "_blank", 1, "btn", "btn-success", "me-1", "mb-1", 3, "href"], [1, "fa-regular", "fa-file-arrow-down", "fa-lg", 3, "click"]],
        template: function FileDetailsSideViewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FileDetailsSideViewComponent_div_0_Template, 38, 14, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.displayFileDetails);
          }
        },
        dependencies: [i3$1.NgIf, i5.CdkCopyToClipboard, i3$1.DatePipe],
        styles: ["#highfield-uploads-shared-file-details-side-view-container[_ngcontent-%COMP%], #highfield-uploads-shared-file-details-side-view-container[_ngcontent-%COMP%]   .detals[_ngcontent-%COMP%]{overflow-wrap:break-word;word-break:break-all}#highfield-uploads-shared-file-details-side-view-container[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%] > .col-lg-4[_ngcontent-%COMP%]{overflow-wrap:break-word;word-break:break-all;white-space:nowrap}#highfield-uploads-shared-file-details-side-view-container[_ngcontent-%COMP%]   .h4[_ngcontent-%COMP%], #highfield-uploads-shared-file-details-side-view-container[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{overflow-wrap:break-word;word-break:break-all}#highfield-uploads-shared-file-details-side-view-container[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{min-width:161px;min-height:40px;text-align:center;line-height:1.1em;font-size:1.1em}.cell-1[_ngcontent-%COMP%]{width:170px}"]
      });
    }
  }
  return FileDetailsSideViewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedModule = /*#__PURE__*/(() => {
  class SharedModule {
    static forRoot() {
      return {
        ngModule: SharedModule
      };
    }
    static {
      this.ɵfac = function SharedModule_Factory(t) {
        return new (t || SharedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SharedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, AngularHighfieldauthModule, AngularHighfieldlayoutModule, MatDialogModule, MatMenuModule, MatProgressBarModule, HttpClientModule, ClipboardModule, MatProgressSpinnerModule]
      });
    }
  }
  return SharedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AdminModule = /*#__PURE__*/(() => {
  class AdminModule {
    static forRoot() {
      return {
        ngModule: AdminModule
      };
    }
    static {
      this.ɵfac = function AdminModule_Factory(t) {
        return new (t || AdminModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AdminModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, AdminRoutingModule, AngularHighfieldauthModule, AngularHighfieldwebapiModule, AngularHighfieldlayoutModule, SharedModule]
      });
    }
  }
  return AdminModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ManagePublicComponent = /*#__PURE__*/(() => {
  class ManagePublicComponent {
    constructor(route, router, location) {
      this.route = route;
      this.router = router;
      this.uploadConfig = new FileUploadConfig();
      this.loaded = false;
      this.navigationSubscription = this.router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          if (this.loaded) {
            this.child.ngOnChanges();
          }
        }
      });
      this.location = location;
    }
    ngOnInit() {
      this.loaded = false;
      this.route.data.subscribe(({
        access
      }) => {
        this.linkId = access.linkId;
        this.categoryId = access.categoryId;
        convertReadonly(this.uploadConfig, access.readonly);
      });
      this.loaded = true;
    }
    ngOnDestroy() {
      if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function ManagePublicComponent_Factory(t) {
        return new (t || ManagePublicComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i3$1.Location));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ManagePublicComponent,
        selectors: [["lib-manage"]],
        viewQuery: function ManagePublicComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(UploadedFilesComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.child = _t.first);
          }
        },
        features: [i0.ɵɵProvidersFeature([Location, {
          provide: LocationStrategy,
          useClass: PathLocationStrategy
        }])],
        decls: 4,
        vars: 3,
        consts: [["id", "highfield-cdn-admin-manage-container"], [1, "row", "h-25"], [1, "row"], [3, "linkId", "categoryId", "configuration"]],
        template: function ManagePublicComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "highfield-uploads-shared-uploaded-files", 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("linkId", ctx.linkId);
            i0.ɵɵpropertyInterpolate("categoryId", ctx.categoryId);
            i0.ɵɵproperty("configuration", ctx.uploadConfig);
          }
        },
        dependencies: [UploadedFilesComponent],
        styles: ["#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]{background-color:#fff;margin-right:2vw!important}#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%] > .row[_ngcontent-%COMP%]{width:80vw}"]
      });
    }
  }
  return ManagePublicComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SummaryPublicComponent = /*#__PURE__*/(() => {
  class SummaryPublicComponent {
    constructor(route, router, location) {
      this.route = route;
      this.router = router;
      this.uploadConfig = new FileUploadConfig();
      this.loaded = false;
      this.location = location;
      this.navigationSubscription = this.router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          if (this.loaded) {
            this.child.ngOnInit();
          }
        }
      });
    }
    ngOnInit() {
      this.loaded = false;
      this.route.data.subscribe(({
        access
      }) => {
        this.linkId = access.linkId;
        this.categoryId = access.categoryId;
        convertReadonly(this.uploadConfig, access.readonly);
      });
      this.loaded = true;
    }
    ngOnDestroy() {
      if (this.navigationSubscription) {
        this.navigationSubscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function SummaryPublicComponent_Factory(t) {
        return new (t || SummaryPublicComponent)(i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i3$1.Location));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SummaryPublicComponent,
        selectors: [["lib-overview"]],
        viewQuery: function SummaryPublicComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(UploadedFilesComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.child = _t.first);
          }
        },
        features: [i0.ɵɵProvidersFeature([Location, {
          provide: LocationStrategy,
          useClass: PathLocationStrategy
        }])],
        decls: 4,
        vars: 3,
        consts: [["id", "highfield-cdn-admin-manage-container"], [1, "row", "h-25"], [1, "row"], [3, "linkId", "categoryId", "configuration"]],
        template: function SummaryPublicComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "highfield-uploads-shared-uploaded-files", 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵpropertyInterpolate("linkId", ctx.linkId);
            i0.ɵɵpropertyInterpolate("categoryId", ctx.categoryId);
            i0.ɵɵproperty("configuration", ctx.uploadConfig);
          }
        },
        dependencies: [UploadedFilesComponent],
        styles: [".row[_ngcontent-%COMP%]{width:max-content;display:flex}#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]{background-color:#fff;margin-right:2vw!important}#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%] > .row[_ngcontent-%COMP%]{width:80vw}"]
      });
    }
  }
  return SummaryPublicComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageAccessResolver = /*#__PURE__*/(() => {
  class PageAccessResolver {
    resolve(route, state) {
      return of({
        linkId: '39C9B4D1-974D-42A4-9F9C-2E21A491BA94',
        categoryId: '8290C34D-8680-46AE-9EAC-E6ACF5B178D5',
        readonly: '0'
      });
    }
    static {
      this.ɵfac = function PageAccessResolver_Factory(t) {
        return new (t || PageAccessResolver)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PageAccessResolver,
        factory: PageAccessResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PageAccessResolver;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PageReadonlyAccessResolver = /*#__PURE__*/(() => {
  class PageReadonlyAccessResolver {
    resolve(route, state) {
      return of({
        linkId: "39C9B4D1-974D-42A4-9F9C-2E21A491BA94",
        categoryId: "8290C34D-8680-46AE-9EAC-E6ACF5B178D5",
        readonly: "1"
      });
    }
    static {
      this.ɵfac = function PageReadonlyAccessResolver_Factory(t) {
        return new (t || PageReadonlyAccessResolver)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PageReadonlyAccessResolver,
        factory: PageReadonlyAccessResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PageReadonlyAccessResolver;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WelcomeComponent = /*#__PURE__*/(() => {
  class WelcomeComponent {
    static {
      this.ɵfac = function WelcomeComponent_Factory(t) {
        return new (t || WelcomeComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WelcomeComponent,
        selectors: [["highfield-uploads-welcome"]],
        decls: 9,
        vars: 0,
        consts: [["routerLink", "/login", "routerLinkActive", "active"], ["routerLink", "/admin", "routerLinkActive", "active"]],
        template: function WelcomeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h1");
            i0.ɵɵtext(1, "Welcome to the Highfield Uploads System");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "ul")(3, "li")(4, "a", 0);
            i0.ɵɵtext(5, "Login");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "li")(7, "a", 1);
            i0.ɵɵtext(8, "Admin Area");
            i0.ɵɵelementEnd()()();
          }
        },
        dependencies: [i1$2.RouterLink, i1$2.RouterLinkActive]
      });
    }
  }
  return WelcomeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const publicRoutes = [{
  path: "",
  redirectTo: 'welcome',
  pathMatch: 'full'
}, {
  path: "welcome",
  component: WelcomeComponent
}, {
  path: "login",
  component: LoginComponent
}, {
  path: "summary",
  component: SummaryPublicComponent,
  resolve: {
    access: PageReadonlyAccessResolver
  }
}, {
  path: "manage",
  component: ManagePublicComponent,
  resolve: {
    access: PageAccessResolver
  }
}, {
  path: "video/:id",
  component: PlayVideoComponent
}, {
  path: "audio/:id",
  component: PlayAudioComponent
}];
let PublicRoutingModule = /*#__PURE__*/(() => {
  class PublicRoutingModule {
    static {
      this.ɵfac = function PublicRoutingModule_Factory(t) {
        return new (t || PublicRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PublicRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild(publicRoutes), RouterModule]
      });
    }
  }
  return PublicRoutingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PublicModule = /*#__PURE__*/(() => {
  class PublicModule {
    static forRoot() {
      return {
        ngModule: PublicModule
      };
    }
    static {
      this.ɵfac = function PublicModule_Factory(t) {
        return new (t || PublicModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PublicModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, PublicRoutingModule, AngularHighfieldauthModule, AngularHighfieldlayoutModule, AngularHighfieldwebapiModule, SharedModule]
      });
    }
  }
  return PublicModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LinkService = /*#__PURE__*/(() => {
  class LinkService {
    constructor() {
      this.linkId = '';
      this.parameters = new Map();
    }
    setLinkId(value) {
      this.linkId = value;
    }
    getLinkId() {
      return this.linkId;
    }
    setCategoryId(value) {
      this.categoryId = value;
    }
    getCategoryId() {
      return this.categoryId;
    }
    setParameterValue(name, value) {
      this.parameters.set(name.toLowerCase(), value);
    }
    getParameterValue(name) {
      if (this.parameters.has(name.toLowerCase())) {
        return this.parameters.get(name.toLowerCase());
      } else {
        return '';
      }
    }
    setupLinks(routeSnapshot) {
      if (routeSnapshot.queryParams['linkid'] !== '') {
        this.setLinkId(routeSnapshot.queryParams['linkid']);
        this.setCategoryId(routeSnapshot.queryParams['categoryid']);
      }
      for (var i = 0; i < routeSnapshot.queryParamMap.keys.length; i++) {
        if (routeSnapshot.queryParamMap.keys[i].toLowerCase() !== 'linkid' && routeSnapshot.queryParamMap.keys[i].toLowerCase() !== 'categoryid') {
          this.setParameterValue(routeSnapshot.queryParamMap.keys[i], routeSnapshot.queryParams[routeSnapshot.queryParamMap.keys[i]]);
        }
      }
    }
    static {
      this.ɵfac = function LinkService_Factory(t) {
        return new (t || LinkService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LinkService,
        factory: LinkService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LinkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FileManagerComponent = /*#__PURE__*/(() => {
  class FileManagerComponent {
    constructor(router, route, linkService) {
      this.router = router;
      this.route = route;
      this.linkService = linkService;
      this.uploadConfig = new FileUploadConfig();
    }
    async ngOnInit() {
      if (this.route.snapshot.queryParams['linkid'] !== '') {
        this.linkService.setLinkId(this.route.snapshot.queryParams['linkid']);
        this.linkService.setCategoryId(this.route.snapshot.queryParams['categoryid']);
      }
      for (var i = 0; i < this.route.snapshot.queryParamMap.keys.length; i++) {
        if (this.route.snapshot.queryParamMap.keys[i].toLowerCase() !== 'linkid' && this.route.snapshot.queryParamMap.keys[i].toLowerCase() !== 'categoryid') {
          this.linkService.setParameterValue(this.route.snapshot.queryParamMap.keys[i], this.route.snapshot.queryParams[this.route.snapshot.queryParamMap.keys[i]]);
        }
      }
      this.route.data.subscribe(({
        access
      }) => {
        convertReadonly(this.uploadConfig, access.readonly);
      });
      this.linkId = this.linkService.getLinkId();
      this.categoryId = this.linkService.getCategoryId();
    }
    static {
      this.ɵfac = function FileManagerComponent_Factory(t) {
        return new (t || FileManagerComponent)(i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i1$2.ActivatedRoute), i0.ɵɵdirectiveInject(LinkService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FileManagerComponent,
        selectors: [["highfield-uploads-embedded"]],
        decls: 1,
        vars: 3,
        consts: [[3, "linkId", "categoryId", "configuration"]],
        template: function FileManagerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "highfield-uploads-shared-uploaded-files", 0);
          }
          if (rf & 2) {
            i0.ɵɵpropertyInterpolate("linkId", ctx.linkId);
            i0.ɵɵpropertyInterpolate("categoryId", ctx.categoryId);
            i0.ɵɵproperty("configuration", ctx.uploadConfig);
          }
        },
        dependencies: [UploadedFilesComponent],
        styles: ["#highfield-cdn-admin-manage-container[_ngcontent-%COMP%]{width:80vw;background-color:#fff;margin-right:2vw!important}"]
      });
    }
  }
  return FileManagerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AdminPageAccessResolver = /*#__PURE__*/(() => {
  class AdminPageAccessResolver {
    resolve(route, state) {
      return of({
        linkId: route.paramMap.get("linkid"),
        categoryId: route.paramMap.get("categoryid"),
        readonly: '0'
      });
    }
    static {
      this.ɵfac = function AdminPageAccessResolver_Factory(t) {
        return new (t || AdminPageAccessResolver)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AdminPageAccessResolver,
        factory: AdminPageAccessResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AdminPageAccessResolver;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomerPageAccessResolver = /*#__PURE__*/(() => {
  class CustomerPageAccessResolver {
    resolve(route, state) {
      return of({
        linkId: route.paramMap.get("linkid"),
        categoryId: route.paramMap.get("categoryid"),
        readonly: '1'
      });
    }
    static {
      this.ɵfac = function CustomerPageAccessResolver_Factory(t) {
        return new (t || CustomerPageAccessResolver)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CustomerPageAccessResolver,
        factory: CustomerPageAccessResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CustomerPageAccessResolver;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const embeddedRoutes = [{
  path: "",
  redirectTo: 'filemanager',
  pathMatch: 'full'
}, {
  path: "filemanager",
  component: FileManagerComponent,
  resolve: {
    access: AdminPageAccessResolver
  }
}, {
  path: "customerfilemanager",
  component: FileManagerComponent,
  resolve: {
    access: CustomerPageAccessResolver
  }
}, {
  path: "video/:id",
  component: PlayVideoComponent
}, {
  path: "audio/:id",
  component: PlayAudioComponent
}];
let EmbeddedRoutingModule = /*#__PURE__*/(() => {
  class EmbeddedRoutingModule {
    static {
      this.ɵfac = function EmbeddedRoutingModule_Factory(t) {
        return new (t || EmbeddedRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EmbeddedRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild(embeddedRoutes), RouterModule]
      });
    }
  }
  return EmbeddedRoutingModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmbeddedModule = /*#__PURE__*/(() => {
  class EmbeddedModule {
    static forRoot() {
      return {
        ngModule: EmbeddedModule
      };
    }
    static {
      this.ɵfac = function EmbeddedModule_Factory(t) {
        return new (t || EmbeddedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EmbeddedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, EmbeddedRoutingModule, AngularHighfieldauthModule, AngularHighfieldwebapiModule, AngularHighfieldlayoutModule, SharedModule]
      });
    }
  }
  return EmbeddedModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UploadedSummary {}
const CDNPortalAdminLinks = [{
  name: 'Information Resources',
  iconClass: 'fa-solid fa-address-card',
  baseRoute: '/InformationResources',
  order: 0,
  default: true,
  topMenuItems: [{
    name: 'Manage',
    childRoute: '/manage',
    order: 0,
    default: true
  }]
}];
const CDNPortalPublicLinks = [{
  name: 'Information Resources',
  iconClass: 'fa-solid fa-address-card',
  baseRoute: '/InformationResources',
  order: 0,
  default: true,
  topMenuItems: [{
    name: 'DownLoads',
    childRoute: '/manage',
    order: 0,
    default: true
  }]
}];
const CDNPortalReadonlyLinks = [{
  name: 'Information Resources',
  iconClass: 'fa-solid fa-address-card',
  baseRoute: '/InformationResources',
  order: 0,
  default: true,
  topMenuItems: [{
    name: 'Summary',
    childRoute: '/summary',
    order: 0,
    default: true
  }]
}];

/*
 * Public API Surface of angular-highfield-cdn
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddFolderComponent, AdminModule, AdminRoutingModule, AngularHighfieldCdnModule, BlobService, CDNPortalAdminLinks, CDNPortalPublicLinks, CDNPortalReadonlyLinks, EmbeddedModule, EmbeddedRoutingModule, FileDetailsComponent, FileManagerComponent, FileService, FileUploadConfig, FileUploadMultipleComponent, ManageComponent, ManagePublicComponent, NodeActionComponent, OverviewComponent, PlayAudioComponent, PlayVideoComponent, PublicModule, PublicRoutingModule, SharedModule, SummaryPublicComponent, TreeListComponent, UploadedFilesComponent, UploadedSummary, WelcomeComponent, adminRoutes, convertReadonly, embeddedRoutes, publicRoutes };
